export const tokenList =  [
    {
        "chainId": 369,
        "name": "Wrapped Pulse",
        "address": "0xA1077a294dDE1B09bB078844df40758a5D0f9a27",
        "symbol": "WPLS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xA1077a294dDE1B09bB078844df40758a5D0f9a27.png"
    },
    {
        "chainId": 369,
        "name": "HEX",
        "address": "0x2b591e99afE9f32eAA6214f7B7629768c40Eeb39",
        "symbol": "HEX",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x2b591e99afE9f32eAA6214f7B7629768c40Eeb39.png"
    },
    {
        "chainId": 369,
        "name": "HEX from Ethereum",
        "address": "0x57fde0a71132198BBeC939B98976993d8D89D225",
        "symbol": "eHEX",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x57fde0a71132198BBeC939B98976993d8D89D225.png"
    },
    {
        "chainId": 369,
        "name": "PulseX",
        "address": "0x95B303987A60C71504D99Aa1b13B4DA07b0790ab",
        "symbol": "PLSX",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x95B303987A60C71504D99Aa1b13B4DA07b0790ab.png"
    },
    {
        "chainId": 369,
        "name": "Incentive",
        "address": "0x2fa878Ab3F87CC1C9737Fc071108F904c0B0C95d",
        "symbol": "INC",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x2fa878Ab3F87CC1C9737Fc071108F904c0B0C95d.png"
    },
    {
        "chainId": 369,
        "name": "Dai from Ethereum",
        "address": "0xefD766cCb38EaF1dfd701853BFCe31359239F305",
        "symbol": "DAI",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xefD766cCb38EaF1dfd701853BFCe31359239F305.png"
    },
    {
        "chainId": 369,
        "address": "0x15D38573d2feeb82e7ad5187aB8c1D52810B1f07",
        "name": "USD Coin from Ethereum",
        "symbol": "USDC",
        "decimals": 6,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x15D38573d2feeb82e7ad5187aB8c1D52810B1f07.png"
    },
    {
        "chainId": 369,
        "name": "Tether USD from Ethereum",
        "address": "0x0Cb6F5a34ad42ec934882A05265A7d5F59b51A2f",
        "symbol": "USDT",
        "decimals": 6,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x0Cb6F5a34ad42ec934882A05265A7d5F59b51A2f.png"
    },
    {
        "chainId": 369,
        "name": "Wrapped Ether from Ethereum",
        "address": "0x02DcdD04e3F455D838cd1249292C58f3B79e3C3C",
        "symbol": "WETH",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x02DcdD04e3F455D838cd1249292C58f3B79e3C3C.png"
    },
    {
        "chainId": 369,
        "name": "Wrapped BTC from Ethereum",
        "address": "0xb17D901469B9208B17d916112988A3FeD19b5cA1",
        "symbol": "WBTC",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xb17D901469B9208B17d916112988A3FeD19b5cA1.png"
    },
    {
        "chainId": 369,
        "name": "Wrapped BTC",
        "address": "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        "symbol": "pWBTC",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599.png"
    },
    {
        "chainId": 369,
        "name": "Piteas Token",
        "address": "0x2A06a971fE6ffa002fd242d437E3db2b5cC5B433",
        "symbol": "PTS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x2A06a971fE6ffa002fd242d437E3db2b5cC5B433.png"
    },
    {
        "chainId": 369,
        "name": "Dai Stablecoin",
        "address": "0x6B175474E89094C44Da98b954EedeAC495271d0F",
        "symbol": "pDAI",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6B175474E89094C44Da98b954EedeAC495271d0F.png"
    },
    {
        "chainId": 369,
        "name": "Tether USD",
        "address": "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        "symbol": "pUSDT",
        "decimals": 6,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xdAC17F958D2ee523a2206206994597C13D831ec7.png"
    },
    {
        "chainId": 369,
        "name": "USD Coin",
        "address": "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        "symbol": "pUSDC",
        "decimals": 6,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48.png"
    },
    {
        "chainId": 369,
        "name": "USD Coin from Hyperlane",
        "address": "0xa5B0D537CeBE97f087Dc5FE5732d70719caaEc1D",
        "symbol": "hUSDC",
        "decimals": 6,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xa5B0D537CeBE97f087Dc5FE5732d70719caaEc1D.png"
    },
    {
        "chainId": 369,
        "name": "Hedron",
        "address": "0x3819f64f282bf135d62168C1e513280dAF905e06",
        "symbol": "HDRN",
        "decimals": 9,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x3819f64f282bf135d62168C1e513280dAF905e06.png"
    },
    {
        "chainId": 369,
        "name": "Hedron from Ethereum",
        "address": "0xAbF663531FA10ab8116cbf7d5c6229B018A26Ff9",
        "symbol": "eHDRN",
        "decimals": 9,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xAbF663531FA10ab8116cbf7d5c6229B018A26Ff9.png"
    },
    {
        "chainId": 369,
        "name": "Icosa",
        "address": "0xfc4913214444aF5c715cc9F7b52655e788A569ed",
        "symbol": "ICSA",
        "decimals": 9,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xfc4913214444aF5c715cc9F7b52655e788A569ed.png"
    },
    {
        "chainId": 369,
        "name": "Icosa from Ethereum",
        "address": "0xb4d363D5dF85f0fBc746c236Fd410d82BF856f78",
        "symbol": "ICSA",
        "decimals": 9,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xb4d363D5dF85f0fBc746c236Fd410d82BF856f78.png"
    },
    {
        "chainId": 369,
        "name": "Maximus Lucky",
        "address": "0x6B0956258fF7bd7645aa35369B55B61b8e6d6140",
        "symbol": "LUCKY",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6B0956258fF7bd7645aa35369B55B61b8e6d6140.png"
    },
    {
        "chainId": 369,
        "name": "PulseBitcoin",
        "address": "0x5EE84583f67D5EcEa5420dBb42b462896E7f8D06",
        "symbol": "PLSB",
        "decimals": 12,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x5EE84583f67D5EcEa5420dBb42b462896E7f8D06.png"
    },
    {
        "chainId": 369,
        "name": "Maximus Trio",
        "address": "0xF55cD1e399e1cc3D95303048897a680be3313308",
        "symbol": "TRIO",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xF55cD1e399e1cc3D95303048897a680be3313308.png"
    },
    {
        "chainId": 369,
        "name": "Maximus from Ethereum",
        "address": "0x352511c9bC5D47DBC122883Ed9353E987d10A3BA",
        "symbol": "eMAXI",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x352511c9bC5D47DBC122883Ed9353E987d10A3BA.png"
    },
    {
        "chainId": 369,
        "name": "Maximus Decimus from Ethereum",
        "address": "0x189a3CA3cC1337e85c7bC0a43b8d3457FD5AaE89",
        "symbol": "eDECI",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x189a3CA3cC1337e85c7bC0a43b8d3457FD5AaE89.png"
    },
    {
        "chainId": 369,
        "name": "ASIC Token",
        "address": "0x347a96a5BD06D2E15199b032F46fB724d6c73047",
        "symbol": "ASIC",
        "decimals": 12,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x347a96a5BD06D2E15199b032F46fB724d6c73047.png"
    },
    {
        "chainId": 369,
        "name": "Solana from Ethereum",
        "address": "0x1c3C50bd18E3f0C7c23666b8e8a843238A359386",
        "symbol": "SOL",
        "decimals": 9,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x1c3C50bd18E3f0C7c23666b8e8a843238A359386.png"
    },
    {
        "chainId": 369,
        "name": "Phiat Token",
        "address": "0x96E035ae0905EFaC8F733f133462f971Cfa45dB1",
        "symbol": "PHIAT",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x96E035ae0905EFaC8F733f133462f971Cfa45dB1.png"
    },
    {
        "chainId": 369,
        "name": "ePhiat from Ethereum",
        "address": "0xfE39FDc0012DCf10C9f674ea7e74889e4d71a226",
        "symbol": "ePhiat",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xfE39FDc0012DCf10C9f674ea7e74889e4d71a226.png"
    },
    {
        "chainId": 369,
        "name": "9MM",
        "address": "0x7b39712Ef45F7dcED2bBDF11F3D5046bA61dA719",
        "symbol": "9MM",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x7b39712Ef45F7dcED2bBDF11F3D5046bA61dA719.png"
    },
    {
        "chainId": 369,
        "name": "Daytona Finance",
        "address": "0x9F8182aD65c53Fd78bd07648a1b3DDcB675c6772",
        "symbol": "TONI",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x9F8182aD65c53Fd78bd07648a1b3DDcB675c6772.png"
    },
    {
        "chainId": 369,
        "name": "Pepe on Pulsechain",
        "address": "0x6982508145454Ce325dDbE47a25d4ec3d2311933",
        "symbol": "pPEPE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6982508145454Ce325dDbE47a25d4ec3d2311933.png"
    },
    {
        "chainId": 369,
        "name": "Pepe from Ethereum",
        "address": "0x4d3AeA379b7689E0Cb722826C909Fab39E54123d",
        "symbol": "ePEPE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x4d3AeA379b7689E0Cb722826C909Fab39E54123d.png"
    },
    {
        "chainId": 369,
        "name": "Cronos Coin",
        "address": "0xA0b73E1Ff0B80914AB6fe0444E65848C4C34450b",
        "symbol": "CRO",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xA0b73E1Ff0B80914AB6fe0444E65848C4C34450b.png"
    },
    {
        "chainId": 369,
        "name": "Maximus BASE",
        "address": "0xe9f84d418B008888A992Ff8c6D22389C2C3504e0",
        "symbol": "BASE",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xe9f84d418B008888A992Ff8c6D22389C2C3504e0.png"
    },
    {
        "chainId": 369,
        "name": "T.I.M.E. Dividend",
        "address": "0xCA35638A3fdDD02fEC597D8c1681198C06b23F58",
        "symbol": "TIME",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xCA35638A3fdDD02fEC597D8c1681198C06b23F58.png"
    },
    {
        "chainId": 369,
        "name": "Internet Money",
        "address": "0xBBcF895BFCb57d0f457D050bb806d1499436c0CE",
        "symbol": "IM",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xBBcF895BFCb57d0f457D050bb806d1499436c0CE.png"
    },
    {
        "chainId": 369,
        "name": "TrueUSD on Pulsechain",
        "address": "0x0000000000085d4780B73119b644AE5ecd22b376",
        "symbol": "pTUSD",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x0000000000085d4780B73119b644AE5ecd22b376.png"
    },
    {
        "chainId": 369,
        "name": "9INCH",
        "address": "0x3ca80d83277e721171284667829c686527B8b3c5",
        "symbol": "9INCH",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x3ca80d83277e721171284667829c686527B8b3c5.png"
    },
    {
        "chainId": 369,
        "name": "9INCH from Ethereum",
        "address": "0xeD22494279e0F3F1Ab491F823c6eC4055afeB21F",
        "symbol": "9INCH",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xeD22494279e0F3F1Ab491F823c6eC4055afeB21F.png"
    },
    {
        "chainId": 369,
        "name": "Big Bonus Coin",
        "address": "0x8b4cfb020aF9AcAd95AD80020cE8f67FBB2C700E",
        "symbol": "BBC",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x8b4cfb020aF9AcAd95AD80020cE8f67FBB2C700E.png"
    },
    {
        "chainId": 369,
        "name": "USDL Stablecoin",
        "address": "0x0dEEd1486bc52aA0d3E6f8849cEC5adD6598A162",
        "symbol": "USDL",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x0dEEd1486bc52aA0d3E6f8849cEC5adD6598A162.png"
    },
    {
        "chainId": 369,
        "name": "LOAN",
        "address": "0x9159f1D2a9f51998Fc9Ab03fbd8f265ab14A1b3B",
        "symbol": "LOAN",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x9159f1D2a9f51998Fc9Ab03fbd8f265ab14A1b3B.png"
    },
    {
        "chainId": 369,
        "name": "WATT",
        "address": "0xDfdc2836FD2E63Bba9f0eE07901aD465Bff4DE71",
        "symbol": "WATT",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xDfdc2836FD2E63Bba9f0eE07901aD465Bff4DE71.png"
    },
    {
        "chainId": 369,
        "name": "PXDC Stablecoin",
        "address": "0xeB6b7932Da20c6D7B3a899D5887d86dfB09A6408",
        "symbol": "PXDC",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xeB6b7932Da20c6D7B3a899D5887d86dfB09A6408.png"
    },
    {
        "chainId": 369,
        "name": "EARN",
        "address": "0xb513038BbFdF9D40B676F41606f4F61D4b02c4A2",
        "symbol": "EARN",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xb513038BbFdF9D40B676F41606f4F61D4b02c4A2.png"
    },
    {
        "chainId": 369,
        "name": "FLEX",
        "address": "0x9c6fA17D92898B684676993828143596894AA2A6",
        "symbol": "FLEX",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x9c6fA17D92898B684676993828143596894AA2A6.png"
    },
    {
        "chainId": 369,
        "name": "HEXDC Stablecoin",
        "address": "0x1FE0319440A672526916C232EAEe4808254Bdb00",
        "symbol": "HEXDC",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x1FE0319440A672526916C232EAEe4808254Bdb00.png"
    },
    {
        "chainId": 369,
        "name": "uP Token",
        "address": "0x131bF51e864024DF1982F2cd7B1C786e1A005152",
        "symbol": "uP",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x131bF51e864024DF1982F2cd7B1C786e1A005152.png"
    },
    {
        "chainId": 369,
        "name": "PoorPleb",
        "address": "0x9565c2036963697786705120Fc59310F747bCfD0",
        "symbol": "PP",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x9565c2036963697786705120Fc59310F747bCfD0.png"
    },
    {
        "chainId": 369,
        "name": "PoorPleb from Ethereum",
        "address": "0x75DB6c0115bAE972979bAcCce94E3B8a21A48C4E",
        "symbol": "PP",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x75DB6c0115bAE972979bAcCce94E3B8a21A48C4E.png"
    },
    {
        "chainId": 369,
        "name": "Pulsedoge",
        "address": "0x52Ada28F70BC8EBe5dd4381120d3CD76863919A8",
        "symbol": "PLD",
        "decimals": 0,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x52Ada28F70BC8EBe5dd4381120d3CD76863919A8.png"
    },
    {
        "chainId": 369,
        "name": "Maximus Decimus",
        "address": "0x6b32022693210cD2Cfc466b9Ac0085DE8fC34eA6",
        "symbol": "DECI",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6b32022693210cD2Cfc466b9Ac0085DE8fC34eA6.png"
    },
    {
        "chainId": 369,
        "name": "Maximus Team",
        "address": "0xB7c9E99Da8A857cE576A830A9c19312114d9dE02",
        "symbol": "TEAM",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xB7c9E99Da8A857cE576A830A9c19312114d9dE02.png"
    },
    {
        "chainId": 369,
        "name": "Maximus",
        "address": "0x0d86EB9f43C57f6FF3BC9E23D8F9d82503f0e84b",
        "symbol": "MAXI",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x0d86EB9f43C57f6FF3BC9E23D8F9d82503f0e84b.png"
    },
    {
        "chainId": 369,
        "name": "Love.io",
        "address": "0xb55EE890426341FE45EE6dc788D2D93d25B59063",
        "symbol": "LOVE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xb55EE890426341FE45EE6dc788D2D93d25B59063.png"
    },
    {
        "chainId": 369,
        "name": "TEXAN Token",
        "address": "0xcFCFfE432A48dB53F59c301422d2EdD77B2A88d7",
        "symbol": "TEXAN",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xcFCFfE432A48dB53F59c301422d2EdD77B2A88d7.png"
    },
    {
        "chainId": 369,
        "name": "PHUX Governance Token",
        "address": "0x9663c2d75ffd5F4017310405fCe61720aF45B829",
        "symbol": "PHUX",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x9663c2d75ffd5F4017310405fCe61720aF45B829.png"
    },
    {
        "chainId": 369,
        "name": "PHAME",
        "address": "0x8854bC985fB5725F872c8856bEA11B917cAEb2fE",
        "symbol": "PHAME",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x8854bC985fB5725F872c8856bEA11B917cAEb2fE.png"
    },
    {
        "chainId": 369,
        "name": "Euro Tether",
        "address": "0xC581b735A1688071A1746c968e0798D642EDE491",
        "symbol": "pEURT",
        "decimals": 6,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xC581b735A1688071A1746c968e0798D642EDE491.png"
    },
    {
        "chainId": 369,
        "name": "EazySwap Token",
        "address": "0x6cF99BAA0a4d079F960216d08cf9a1Bc7e4dd37C",
        "symbol": "EAZY",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6cF99BAA0a4d079F960216d08cf9a1Bc7e4dd37C.png"
    },
    {
        "chainId": 369,
        "name": "Tetra Token",
        "address": "0xAeC4C07537B03E3E62fc066EC62401Aed5Fdd361",
        "symbol": "TETRAp",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xAeC4C07537B03E3E62fc066EC62401Aed5Fdd361.png"
    },
    {
        "chainId": 369,
        "name": "Shiba Inu",
        "address": "0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE",
        "symbol": "SHIB",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE.png"
    },
    {
        "chainId": 369,
        "name": "Aave Token",
        "address": "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
        "symbol": "pAAVE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9.png"
    },
    {
        "chainId": 369,
        "name": "Staked ETH on PulseChain",
        "address": "0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84",
        "symbol": "pSTETH",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84.png"
    },
    {
        "chainId": 369,
        "name": "Render Token on PulseChain",
        "address": "0x6De037ef9aD2725EB40118Bb1702EBb27e4Aeb24",
        "symbol": "pRNDR",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6De037ef9aD2725EB40118Bb1702EBb27e4Aeb24.png"
    },
    {
        "chainId": 369,
        "name": "Paxos Gold on PulseChain",
        "address": "0x45804880De22913dAFE09f4980848ECE6EcbAf78",
        "symbol": "pPAXG",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x45804880De22913dAFE09f4980848ECE6EcbAf78.png"
    },
    {
        "chainId": 369,
        "name": "Uniswap from Ethereum",
        "address": "0x3f105121A10247DE9a92e818554DD5Fcd2063AE7",
        "symbol": "UNI",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x3f105121A10247DE9a92e818554DD5Fcd2063AE7.png"
    },
    {
        "chainId": 369,
        "name": "ChainLink Token from Ethereum",
        "address": "0xEe2D275Dbb79c7871F8C6eB2A4D0687dD85409D1",
        "symbol": "LINK",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xEe2D275Dbb79c7871F8C6eB2A4D0687dD85409D1.png"
    },
    {
        "chainId": 369,
        "name": "ChainLink Token",
        "address": "0x514910771AF9Ca656af840dff83E8264EcF986CA",
        "symbol": "pLINK",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x514910771AF9Ca656af840dff83E8264EcF986CA.png"
    },
    {
        "chainId": 369,
        "name": "Poly Maximus",
        "address": "0x9d93692E826A4bd9e903e2A27D7FbD1e116efdad",
        "symbol": "POLY",
        "decimals": 9,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x9d93692E826A4bd9e903e2A27D7FbD1e116efdad.png"
    },
    {
        "chainId": 369,
        "name": "HELGO",
        "address": "0x0567CA0dE35606E9C260CC2358404B11DE21DB44",
        "symbol": "HELGO",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x0567CA0dE35606E9C260CC2358404B11DE21DB44.png"
    },
    {
        "chainId": 369,
        "name": "WAIT",
        "address": "0x26179a4d4B58b4456F28d19507546596c9058ee5",
        "symbol": "WAIT",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x26179a4d4B58b4456F28d19507546596c9058ee5.png"
    },
    {
        "chainId": 369,
        "name": "Hocus Pocus Finance",
        "address": "0xd22E78C22D7E77229d60cc9fC57b0E294F54488E",
        "symbol": "HOC",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xd22E78C22D7E77229d60cc9fC57b0E294F54488E.png"
    },
    {
        "chainId": 369,
        "name": "Apin Pulse",
        "address": "0xBb101431d43b0E1fc31f000bf96826794806e0b4",
        "symbol": "APC",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xBb101431d43b0E1fc31f000bf96826794806e0b4.png"
    },
    {
        "chainId": 369,
        "name": "Real BIG Coin",
        "address": "0x43eaba2E2d2F32f1207A11a18679287Dc7700015",
        "symbol": "RBC",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x43eaba2E2d2F32f1207A11a18679287Dc7700015.png"
    },
    {
        "chainId": 369,
        "name": "KEK",
        "address": "0xE362401D1451E8eb38fD66d0c9E23fB080409aB9",
        "symbol": "KEK",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xE362401D1451E8eb38fD66d0c9E23fB080409aB9.png"
    },
    {
        "chainId": 369,
        "name": "Coast",
        "address": "0x600136dA8cc6D1Ea07449514604dc4ab7098dB82",
        "symbol": "CST",
        "decimals": 6,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x600136dA8cc6D1Ea07449514604dc4ab7098dB82.png"
    },
    {
        "chainId": 369,
        "name": "TIDE Governance Token",
        "address": "0xdedBCc8D9458B2556375680FbA297C6aCa6c7DCf",
        "symbol": "TIDE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xdedBCc8D9458B2556375680FbA297C6aCa6c7DCf.png"
    },
    {
        "chainId": 369,
        "name": "Glory",
        "address": "0x37D16BabDce0427e63233b3d9be149B31ac2E6f8",
        "symbol": "GLORY",
        "decimals": 6,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x37D16BabDce0427e63233b3d9be149B31ac2E6f8.png"
    },
    {
        "chainId": 369,
        "name": "Bridged Stable Pool",
        "address": "0xF96d60e9444f19Fe5126888BD53BdE80e58c2851",
        "symbol": "BridgedSP",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xF96d60e9444f19Fe5126888BD53BdE80e58c2851.png"
    },
    {
        "chainId": 369,
        "name": "Prime PHUX",
        "address": "0x545998ABCbf0633C83bA20Cb94f384925BE75dd5",
        "symbol": "PrimePHUX",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x545998ABCbf0633C83bA20Cb94f384925BE75dd5.png"
    },
    {
        "chainId": 369,
        "name": "Phame LP",
        "address": "0xF8bba8B1B1A05992B18051E4e79415364Cbf4539",
        "symbol": "PHLP",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xF8bba8B1B1A05992B18051E4e79415364Cbf4539.png"
    },
    {
        "chainId": 369,
        "name": "Phame LP v2",
        "address": "0x7eE9946b082E197652Bf5d4Bdc2A034DBfF4121b",
        "symbol": "PHLPv2",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x7eE9946b082E197652Bf5d4Bdc2A034DBfF4121b.png"
    },
    {
        "chainId": 369,
        "name": "CST Stable Pool",
        "address": "0x9009c1de3220cAF855F83140E5Ac18A43272eC01",
        "symbol": "CSTStable",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x9009c1de3220cAF855F83140E5Ac18A43272eC01.png"
    },
    {
        "chainId": 369,
        "name": "Oracle and Bridge Stable Pool",
        "address": "0xB272AE05C5F5eCE5a3a599928c06469ebc73FC31",
        "symbol": "OBStable",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xB272AE05C5F5eCE5a3a599928c06469ebc73FC31.png"
    },
    {
        "chainId": 369,
        "name": "Maker on Pulsechain",
        "address": "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
        "symbol": "pMKR",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2.png"
    },
    {
        "chainId": 369,
        "name": "OPHIR Token",
        "address": "0xC59Be55D22CB7967ee95e5bE0770e263EE014F78",
        "symbol": "OPHIR",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xC59Be55D22CB7967ee95e5bE0770e263EE014F78.png"
    },
    {
        "chainId": 369,
        "name": "AxisAlive",
        "address": "0x8BDB63033b02C15f113De51EA1C3a96Af9e8ecb5",
        "symbol": "AXIS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x8BDB63033b02C15f113De51EA1C3a96Af9e8ecb5.png"
    },
    {
        "chainId": 369,
        "name": "TSFi",
        "address": "0x4243568Fa2bbad327ee36e06c16824cAd8B37819",
        "symbol": "TSFi",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x4243568Fa2bbad327ee36e06c16824cAd8B37819.png"
    },
    {
        "chainId": 369,
        "name": "Atropa",
        "address": "0xCc78A0acDF847A2C1714D2A925bB4477df5d48a6",
        "symbol": "ATROPA",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xCc78A0acDF847A2C1714D2A925bB4477df5d48a6.png"
    },
    {
        "chainId": 369,
        "name": "dOWN",
        "address": "0x2556F7f8d82EbcdD7b821b0981C38D9dA9439CdD",
        "symbol": "dOWN",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x2556F7f8d82EbcdD7b821b0981C38D9dA9439CdD.png"
    },
    {
        "chainId": 369,
        "name": "Teddy Bear",
        "address": "0xd6c31bA0754C4383A41c0e9DF042C62b5e918f6d",
        "symbol": "BEAR",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xd6c31bA0754C4383A41c0e9DF042C62b5e918f6d.png"
    },
    {
        "chainId": 369,
        "name": "Treasury Bill",
        "address": "0x463413c579D29c26D59a65312657DFCe30D545A1",
        "symbol": "BILL",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x463413c579D29c26D59a65312657DFCe30D545A1.png"
    },
    {
        "chainId": 369,
        "name": "TYRH",
        "address": "0xc91562626B9a697af683555dA9946986278Ac9a5",
        "symbol": "TYRH",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xc91562626B9a697af683555dA9946986278Ac9a5.png"
    },
    {
        "chainId": 369,
        "name": "Hex Orange Address",
        "address": "0x7901a3569679AEc3501dbeC59399F327854a70fe",
        "symbol": "HOA",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x7901a3569679AEc3501dbeC59399F327854a70fe.png"
    },
    {
        "chainId": 369,
        "name": "Meme Coin Mafia",
        "address": "0x78a2809e8e2ef8e07429559f15703Ee20E885588",
        "symbol": "M3M3",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x78a2809e8e2ef8e07429559f15703Ee20E885588.png"
    },
    {
        "chainId": 369,
        "name": "IMPLS Token",
        "address": "0x5f63BC3d5bd234946f18d24e98C324f629D9d60e",
        "symbol": "IMPLS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x5f63BC3d5bd234946f18d24e98C324f629D9d60e.png"
    },
    {
        "chainId": 369,
        "name": "Where Did The ETH Go",
        "address": "0xDe0220b69CE3e855a0124433A8E8D093f53A6bE4",
        "symbol": "WHETH",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xDe0220b69CE3e855a0124433A8E8D093f53A6bE4.png"
    },
    {
        "chainId": 369,
        "name": "Sparkswap",
        "address": "0x6386704cD6f7A584EA9D23cccA66aF7EBA5a727e",
        "symbol": "SPARK",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6386704cD6f7A584EA9D23cccA66aF7EBA5a727e.png"
    },
    {
        "chainId": 369,
        "name": "Genius",
        "address": "0x444444444444C1a66F394025Ac839A535246FCc8",
        "symbol": "GENI",
        "decimals": 9,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x444444444444C1a66F394025Ac839A535246FCc8.png"
    },
    {
        "chainId": 369,
        "name": "B9",
        "address": "0xE676a1E969Feaef164198496bd787e0269f7b237",
        "symbol": "B9",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xE676a1E969Feaef164198496bd787e0269f7b237.png"
    },
    {
        "chainId": 369,
        "name": "Twerk",
        "address": "0xe11a9e0298fBB1248611956db3C8FF556DC1DdbD",
        "symbol": "TWERK",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xe11a9e0298fBB1248611956db3C8FF556DC1DdbD.png"
    },
    {
        "chainId": 369,
        "name": "Pulse Cereal",
        "address": "0x6de1bb62c13394B7Db57a25477DBedD76B3e9a90",
        "symbol": "CEREAL",
        "decimals": 9,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6de1bb62c13394B7Db57a25477DBedD76B3e9a90.png"
    },
    {
        "chainId": 369,
        "name": "Peg Me pDAI",
        "address": "0x924DD489c99614B47385245Df0b5250538c71406",
        "symbol": "PEGD",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x924DD489c99614B47385245Df0b5250538c71406.png"
    },
    {
        "chainId": 369,
        "name": "Granny Token",
        "address": "0xfCf7F3915A899b9133b0D10f6b84F6a849C212Df",
        "symbol": "GRANN",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xfCf7F3915A899b9133b0D10f6b84F6a849C212Df.png"
    },
    {
        "chainId": 369,
        "name": "Wrapped Ether",
        "address": "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        "symbol": "pWETH",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2.png"
    },
    {
        "chainId": 369,
        "name": "monat money Ǝ𒑰",
        "address": "0xf8AB3393b1f5CD6184Fb6800A1fC802043C4063e",
        "symbol": "Ǝ𒑰",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xf8AB3393b1f5CD6184Fb6800A1fC802043C4063e.png"
    },
    {
        "chainId": 369,
        "name": "Mega Inu",
        "address": "0x0E5E2d2480468561dFF0132317615F7D6C27D397",
        "symbol": "MINU",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x0E5E2d2480468561dFF0132317615F7D6C27D397.png"
    },
    {
        "chainId": 369,
        "name": "HEX.COM DIAMOND",
        "address": "0xCF409C91B49DD3F796d20Eec20535fDC79A08798",
        "symbol": "DMND",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xCF409C91B49DD3F796d20Eec20535fDC79A08798.png"
    },
    {
        "chainId": 369,
        "name": "PussyCat",
        "address": "0x733099917CbA30614e4b2ef1de8A551645665143",
        "symbol": "PUSSY",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x733099917CbA30614e4b2ef1de8A551645665143.png"
    },
    {
        "chainId": 369,
        "name": "OG.Incentive",
        "address": "0xF84b84dAAce6Ac00DbBAed26CA32Ff3570Aaf66C",
        "symbol": "OG",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xF84b84dAAce6Ac00DbBAed26CA32Ff3570Aaf66C.png"
    },
    {
        "chainId": 369,
        "name": "GillespieCoin",
        "address": "0x3981920A82d95A117A8747eCF9A11e105Ca38B62",
        "symbol": "GDAY",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x3981920A82d95A117A8747eCF9A11e105Ca38B62.png"
    },
    {
        "chainId": 369,
        "name": "TANGent Golden Yacht",
        "address": "0xdB8E20f794Fa48d36Ae4988dC3D5Ba327df625f8",
        "symbol": "YACHT",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xdB8E20f794Fa48d36Ae4988dC3D5Ba327df625f8.png"
    },
    {
        "chainId": 369,
        "name": "PulseDogecoin",
        "address": "0x34F0915a5f15a66Eba86F6a58bE1A471FB7836A7",
        "symbol": "PLSD",
        "decimals": 12,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x34F0915a5f15a66Eba86F6a58bE1A471FB7836A7.png"
    },
    {
        "chainId": 369,
        "name": "XEN Crypto",
        "address": "0x8a7FDcA264e87b6da72D000f22186B4403081A2a",
        "symbol": "pXEN",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x8a7FDcA264e87b6da72D000f22186B4403081A2a.png"
    },
    {
        "chainId": 369,
        "name": "LUSD Stablecoin",
        "address": "0x5f98805A4E8be255a32880FDeC7F6728C6568bA0",
        "symbol": "pLUSD",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x5f98805A4E8be255a32880FDeC7F6728C6568bA0.png"
    },
    {
        "chainId": 369,
        "name": "PulseHotList",
        "address": "0x3693693695E7a8Ac0ee0ff2f2C4E7B85eAB6c555",
        "symbol": "PHL",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x3693693695E7a8Ac0ee0ff2f2C4E7B85eAB6c555.png"
    },
    {
        "chainId": 369,
        "name": "Mintra",
        "address": "0x207e6b4529840A4fd518f73c68bc9c19B2A15944",
        "symbol": "MINT",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x207e6b4529840A4fd518f73c68bc9c19B2A15944.png"
    },
    {
        "chainId": 369,
        "name": "2PHUX Governance Token",
        "address": "0x115f3Fa979a936167f9D208a7B7c4d85081e84BD",
        "symbol": "2PHUX",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x115f3Fa979a936167f9D208a7B7c4d85081e84BD.png"
    },
    {
        "chainId": 369,
        "name": "Prime2PHUX",
        "address": "0x6d358129Df7Ae10ee925D52e16F71A76D424990B",
        "symbol": "Prime2PHUX",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6d358129Df7Ae10ee925D52e16F71A76D424990B.png"
    },
    {
        "chainId": 369,
        "name": "PulseKitten",
        "address": "0x378b04A0E24DbF08dcA65F3c87aD9dafc1d0dd9d",
        "symbol": "PKTTN",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x378b04A0E24DbF08dcA65F3c87aD9dafc1d0dd9d.png"
    },
    {
        "chainId": 369,
        "name": "TOYBUX",
        "address": "0xcb2c9c2CF13e193F634c84879F375B524e4A73C3",
        "symbol": "TBUX",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xcb2c9c2CF13e193F634c84879F375B524e4A73C3.png"
    },
    {
        "chainId": 369,
        "name": "Communis",
        "address": "0x5A9780Bfe63f3ec57f01b087cD65BD656C9034A8",
        "symbol": "COM",
        "decimals": 12,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x5A9780Bfe63f3ec57f01b087cD65BD656C9034A8.png"
    },
    {
        "chainId": 369,
        "name": "Communis Volume",
        "address": "0xe34Cab4Ccf271f4F149C4Cc43697C5C5810c835a",
        "symbol": "COMV",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xe34Cab4Ccf271f4F149C4Cc43697C5C5810c835a.png"
    },
    {
        "chainId": 369,
        "name": "Basketball",
        "address": "0x35F525BEe58624b89879CDAfAdA040F5840D4460",
        "symbol": "NBA",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x35F525BEe58624b89879CDAfAdA040F5840D4460.png"
    },
    {
        "chainId": 369,
        "name": "uPX",
        "address": "0x664E58570e5835B99d281f12dD14d350315D7E2a",
        "symbol": "uPX",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x664E58570e5835B99d281f12dD14d350315D7E2a.png"
    },
    {
        "chainId": 369,
        "name": "DOGE",
        "address": "0x9CC7437978255e2c38B0d3D4671fb9AC411a68aC",
        "symbol": "DOGE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x9CC7437978255e2c38B0d3D4671fb9AC411a68aC.png"
    },
    {
        "chainId": 369,
        "name": "Glass",
        "address": "0xd687FF2C9C5294f4A2bC0300B46eA921dB312063",
        "symbol": "GLASS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xd687FF2C9C5294f4A2bC0300B46eA921dB312063.png"
    },
    {
        "chainId": 369,
        "name": "PulseInu",
        "address": "0xa12E2661ec6603CBbB891072b2Ad5b3d5edb48bd",
        "symbol": "PINU",
        "decimals": 12,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xa12E2661ec6603CBbB891072b2Ad5b3d5edb48bd.png"
    },
    {
        "chainId": 369,
        "name": "PulseLN Founder Token",
        "address": "0xa685C45fd071DF23278069Db9137e124564897D0",
        "symbol": "PLN",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xa685C45fd071DF23278069Db9137e124564897D0.png"
    },
    {
        "chainId": 369,
        "name": "New World Orange",
        "address": "0x4c00e339F5dC4E97639d6C1c0a0ea4a022a66dB0",
        "symbol": "NWO",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x4c00e339F5dC4E97639d6C1c0a0ea4a022a66dB0.png"
    },
    {
        "chainId": 369,
        "name": "Degen Anonymous",
        "address": "0x075F7F657AEAD0e698EDb4E0A47d1DEF869536B4",
        "symbol": "ANON",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x075F7F657AEAD0e698EDb4E0A47d1DEF869536B4.png"
    },
    {
        "chainId": 369,
        "name": "Baaana Massik",
        "address": "0x637Ecd6b33BD8d5A550939A2e6058Dd7Dc52812e",
        "symbol": "BAANA",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x637Ecd6b33BD8d5A550939A2e6058Dd7Dc52812e.png"
    },
    {
        "chainId": 369,
        "name": "Never Broke Again",
        "address": "0x93Ad3C61f5e39c0DA07fCEbAe0261eAA2d3A9314",
        "symbol": "NBA",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x93Ad3C61f5e39c0DA07fCEbAe0261eAA2d3A9314.png"
    },
    {
        "chainId": 369,
        "name": "PulseCoin",
        "address": "0x4C8218Dc22e478963c02748857245FAD79AAd0c6",
        "symbol": "PLSC",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x4C8218Dc22e478963c02748857245FAD79AAd0c6.png"
    },
    {
        "chainId": 369,
        "name": "Nope",
        "address": "0x8D36123903f504eB81eEB832727af517c0db26bD",
        "symbol": "NOPE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x8D36123903f504eB81eEB832727af517c0db26bD.png"
    },
    {
        "chainId": 369,
        "name": "Degen Protocol GOAT",
        "address": "0xF5D0140B4d53c9476DC1488BC6d8597d7393f074",
        "symbol": "GOAT",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xF5D0140B4d53c9476DC1488BC6d8597d7393f074.png"
    },
    {
        "chainId": 369,
        "name": "Wrapped BNB from BSC",
        "address": "0x518076CCE3729eF1a3877EA3647a26e278e764FE",
        "symbol": "WBNB",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x518076CCE3729eF1a3877EA3647a26e278e764FE.png"
    },
    {
        "chainId": 369,
        "name": "CROWS ㉫",
        "address": "0x203e366A1821570b2f84Ff5ae8B3BdeB48Dc4fa1",
        "symbol": "CROWS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x203e366A1821570b2f84Ff5ae8B3BdeB48Dc4fa1.png"
    },
    {
        "chainId": 369,
        "name": "Carpe Diem Pension",
        "address": "0x6f0dDa6b522fcC7807CcacA4D37eF6958e95E1B9",
        "symbol": "CDP",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6f0dDa6b522fcC7807CcacA4D37eF6958e95E1B9.png"
    },
    {
        "chainId": 369,
        "name": "NO EXPECTATION",
        "address": "0x0016269802dE1FC2dC4F5Cfd2178f721EF2171EE",
        "symbol": "NOEX",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x0016269802dE1FC2dC4F5Cfd2178f721EF2171EE.png"
    },
    {
        "chainId": 369,
        "name": "The Enigma",
        "address": "0x85F1724A1a21a2e4F27C2ffb54a976D5857b2FA0",
        "symbol": "ENIGMA",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x85F1724A1a21a2e4F27C2ffb54a976D5857b2FA0.png"
    },
    {
        "chainId": 369,
        "name": "Rentomania Token",
        "address": "0x8dcf280e9D3f8B988Bba0000428a02C860E50bFf",
        "symbol": "MANIA",
        "decimals": 10,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x8dcf280e9D3f8B988Bba0000428a02C860E50bFf.png"
    },
    {
        "chainId": 369,
        "name": "Cookies",
        "address": "0x7E461D9b06e8B7a4806beB6B9C5C5CB44da3E555",
        "symbol": "COOKIES",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x7E461D9b06e8B7a4806beB6B9C5C5CB44da3E555.png"
    },
    {
        "chainId": 369,
        "name": "Richards Only Brothr",
        "address": "0x1c2766F5949A4aA5d4cf0439067051135ffc1b28",
        "symbol": "ROB",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x1c2766F5949A4aA5d4cf0439067051135ffc1b28.png"
    },
    {
        "chainId": 369,
        "name": "The Grays Currency",
        "address": "0x94534EeEe131840b1c0F61847c572228bdfDDE93",
        "symbol": "pTGC",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x94534EeEe131840b1c0F61847c572228bdfDDE93.png"
    },
    {
        "chainId": 369,
        "name": "Bastard Token",
        "address": "0xD738328b589c6fbfd1Dcff107C4243c73b2e05a9",
        "symbol": "BSTRD",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xD738328b589c6fbfd1Dcff107C4243c73b2e05a9.png"
    },
    {
        "chainId": 369,
        "name": "PulsePot",
        "address": "0xC52F739f544d20725BA7aD47Bb42299034F06f4F",
        "symbol": "PLSP",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xC52F739f544d20725BA7aD47Bb42299034F06f4F.png"
    },
    {
        "chainId": 369,
        "name": "Pulse Inu Puppy",
        "address": "0xe83034A7A78fC148c69defebD6D4C80f8Bb4f710",
        "symbol": "PINU",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xe83034A7A78fC148c69defebD6D4C80f8Bb4f710.png"
    },
    {
        "chainId": 369,
        "name": "HowToPulse",
        "address": "0x7c7ba94b60270BC2c7d98d3498B5ce85B870a749",
        "symbol": "HTP",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x7c7ba94b60270BC2c7d98d3498B5ce85B870a749.png"
    },
    {
        "chainId": 369,
        "name": "Blastar",
        "address": "0x6a44bE19d96f087494Bafa66EE5DF1bf7AAF220f",
        "symbol": "BLAST",
        "decimals": 9,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6a44bE19d96f087494Bafa66EE5DF1bf7AAF220f.png"
    },
    {
        "chainId": 369,
        "name": "𑀭𑀭𑀭𑀭𑀭",
        "address": "0xE35A842eb1EDca4C710B6c1B1565cE7df13f5996",
        "symbol": "BFF",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xE35A842eb1EDca4C710B6c1B1565cE7df13f5996.png"
    },
    {
        "chainId": 369,
        "name": "More",
        "address": "0xbEEf3bB9dA340EbdF0f5bae2E85368140d7D85D0",
        "symbol": "MORE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xbEEf3bB9dA340EbdF0f5bae2E85368140d7D85D0.png"
    },
    {
        "chainId": 369,
        "name": "Galactic Credits V2",
        "address": "0xA74CE5E7C5AB50e22ef0daAfa555f8Cb2B6b9320",
        "symbol": "CREDS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xA74CE5E7C5AB50e22ef0daAfa555f8Cb2B6b9320.png"
    },
    {
        "chainId": 369,
        "name": "BOBO",
        "address": "0x645c33E6ecC5e5FD67Bcc248cAd29B1950E469C6",
        "symbol": "BOBO",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x645c33E6ecC5e5FD67Bcc248cAd29B1950E469C6.png"
    },
    {
        "chainId": 369,
        "name": "Louis The Duck",
        "address": "0x88BdfdBbb5f6DeF9fA1B20eeFDB7FbF41Eb789CB",
        "symbol": "DUCK",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x88BdfdBbb5f6DeF9fA1B20eeFDB7FbF41Eb789CB.png"
    },
    {
        "chainId": 369,
        "name": "2 Cent Club",
        "address": "0x6293373BF0DAE2050641973D49b7b2f71adC91a1",
        "symbol": "2CC",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6293373BF0DAE2050641973D49b7b2f71adC91a1.png"
    },
    {
        "chainId": 369,
        "name": "Bigfoot",
        "address": "0x56c57426795174789dadBb1BA07452270e010448",
        "symbol": "BFX",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x56c57426795174789dadBb1BA07452270e010448.png"
    },
    {
        "chainId": 369,
        "name": "Magic Carpet Ride",
        "address": "0xc42945a98Eaaae8FaFBc76baCE473C90D8100967",
        "symbol": "MAGIC",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xc42945a98Eaaae8FaFBc76baCE473C90D8100967.png"
    },
    {
        "chainId": 369,
        "name": "INT3RC3PTOR",
        "address": "0x7dB3b754883307851e2246Ad6B44D60f42Bf936F",
        "symbol": "INTR",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x7dB3b754883307851e2246Ad6B44D60f42Bf936F.png"
    },
    {
        "chainId": 369,
        "name": "Atropine",
        "address": "0xE846884430D527168B4EAaC80Af9268515D2f0CC",
        "symbol": "PINE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xE846884430D527168B4EAaC80Af9268515D2f0CC.png"
    },
    {
        "chainId": 369,
        "name": "ALIEN",
        "address": "0x1B7B541BeA3aF39292FCe08649e4C4e1BEE408a1",
        "symbol": "ALIEN",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x1B7B541BeA3aF39292FCe08649e4C4e1BEE408a1.png"
    },
    {
        "chainId": 369,
        "name": "DEX",
        "address": "0x57953dAC106a4cDa11D90273b1B9D59E169533c0",
        "symbol": "DEX",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x57953dAC106a4cDa11D90273b1B9D59E169533c0.png"
    },
    {
        "chainId": 369,
        "name": "GOFURS",
        "address": "0x54f667dB585b7B10347429C72c36c8B59aB441cb",
        "symbol": "GOFURS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x54f667dB585b7B10347429C72c36c8B59aB441cb.png"
    },
    {
        "chainId": 369,
        "name": "HEXFIREIO",
        "address": "0xf330cb1d41052dbC74D3325376Cb82E99454e501",
        "symbol": "FIRE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xf330cb1d41052dbC74D3325376Cb82E99454e501.png"
    },
    {
        "chainId": 369,
        "name": "ŽIŽEK",
        "address": "0xe2e1a5d691cCB9E88b84e23A1166B4e6Bd6904Dc",
        "symbol": "ZIZEK",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xe2e1a5d691cCB9E88b84e23A1166B4e6Bd6904Dc.png"
    },
    {
        "chainId": 369,
        "name": "RH404",
        "address": "0x749ccf4c4308490F3c395De897F58e091090B461",
        "symbol": "RH404",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x749ccf4c4308490F3c395De897F58e091090B461.png"
    },
    {
        "chainId": 369,
        "name": "EvmBitcoinToken",
        "address": "0x10d46D6F8f691d3439A781FC5E7BE598Ab67b393",
        "symbol": "E.BTC",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x10d46D6F8f691d3439A781FC5E7BE598Ab67b393.png"
    },
    {
        "chainId": 369,
        "name": "A Free Slice Of Pizza",
        "address": "0x3e7ae951d9925E6e5DE6140a99B90c3259445c9B",
        "symbol": "PIZZA",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x3e7ae951d9925E6e5DE6140a99B90c3259445c9B.png"
    },
    {
        "chainId": 369,
        "name": "PulseTrailerPark",
        "address": "0x880Dd541e00B966d829968c3198F11C8ca38A877",
        "symbol": "PTP",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x880Dd541e00B966d829968c3198F11C8ca38A877.png"
    },
    {
        "chainId": 369,
        "name": "pls.farm",
        "address": "0x90732c0aBC7b44F6e00c4CC90d29293D1DD01d8B",
        "symbol": "COWTIP",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x90732c0aBC7b44F6e00c4CC90d29293D1DD01d8B.png"
    },
    {
        "chainId": 369,
        "name": "sciViVe",
        "address": "0x72a96Ea9DA0C909500eEF1Ef81B433C3A26EB649",
        "symbol": "sciViVe",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x72a96Ea9DA0C909500eEF1Ef81B433C3A26EB649.png"
    },
    {
        "chainId": 369,
        "name": "Maximus Pool Party",
        "address": "0x4581AF35199BBde87a89941220e04E27ce4b0099",
        "symbol": "PARTY",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x4581AF35199BBde87a89941220e04E27ce4b0099.png"
    },
    {
        "chainId": 369,
        "name": "BEAN by Barista",
        "address": "0xd7407BD3E6aD1BAAE0ba9eaFD1Ec41bFE63907B2",
        "symbol": "BEAN",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xd7407BD3E6aD1BAAE0ba9eaFD1Ec41bFE63907B2.png"
    },
    {
        "chainId": 369,
        "name": "Secret Squirrel Society",
        "address": "0x97f7259931f98CC64EbCd993fdE03d71716f3E07",
        "symbol": "NUTS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x97f7259931f98CC64EbCd993fdE03d71716f3E07.png"
    },
    {
        "chainId": 369,
        "name": "Yep",
        "address": "0xE08FC6Ce880D36a1167701028c0ae84dc3e82b8f",
        "symbol": "YEP",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xE08FC6Ce880D36a1167701028c0ae84dc3e82b8f.png"
    },
    {
        "chainId": 369,
        "name": "Mog Coin",
        "address": "0x495d9b70480A22a82D0FB81981480764BA55550e",
        "symbol": "MOG",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x495d9b70480A22a82D0FB81981480764BA55550e.png"
    },
    {
        "chainId": 369,
        "name": "Magic Carpet Ride",
        "address": "0x7FF1C0e8C968a8Ddc1F25e3D891562EA549Ee32e",
        "symbol": "MCR369",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x7FF1C0e8C968a8Ddc1F25e3D891562EA549Ee32e.png"
    },
    {
        "chainId": 369,
        "name": "MOON",
        "address": "0x8E64f0fCa8f0219cEF329ae593Ad6490BE122Ecb",
        "symbol": "MOON",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x8E64f0fCa8f0219cEF329ae593Ad6490BE122Ecb.png"
    },
    {
        "chainId": 369,
        "name": "GIFFORDwear",
        "address": "0x6e86e2b8be6228d1c12aA9d82f5Ec3F27A88Ecce",
        "symbol": "GIFF",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6e86e2b8be6228d1c12aA9d82f5Ec3F27A88Ecce.png"
    },
    {
        "chainId": 369,
        "name": "Monsters INC",
        "address": "0xa8DCD0EB29f6F918289b5C14634C1B5F443Af826",
        "symbol": "MIKE",
        "decimals": 9,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xa8DCD0EB29f6F918289b5C14634C1B5F443Af826.png"
    },
    {
        "chainId": 369,
        "name": "Function Island",
        "address": "0xDFB10795E6fE7D0Db68F9778Ba4C575a28E8Cd4c",
        "symbol": "ISLAND",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xDFB10795E6fE7D0Db68F9778Ba4C575a28E8Cd4c.png"
    },
    {
        "chainId": 369,
        "name": "Launch",
        "address": "0xe101c848620E762ecB942356962dd415342B4fEB",
        "symbol": "LAUNCH",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xe101c848620E762ecB942356962dd415342B4fEB.png"
    },
    {
        "chainId": 369,
        "name": "The Reptilian Currency",
        "address": "0xe2892C876c5e52a4413Ba5f373D1a6E5f2e9116D",
        "symbol": "TRC",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xe2892C876c5e52a4413Ba5f373D1a6E5f2e9116D.png"
    },
    {
        "chainId": 369,
        "name": "dickwifbutt",
        "address": "0xAEbcD0F8f69ECF9587e292bdfc4d731c1abedB68",
        "symbol": "DWB",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xAEbcD0F8f69ECF9587e292bdfc4d731c1abedB68.png"
    },
    {
        "chainId": 369,
        "name": "Function Island Farm",
        "address": "0xfd4d3A2fd12C7f3146428a2ebDCb489550Ae9bea",
        "symbol": "FARM",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xfd4d3A2fd12C7f3146428a2ebDCb489550Ae9bea.png"
    },
    {
        "chainId": 369,
        "name": "Rick Ross Pear",
        "address": "0xA5beB85e5F82419Ab6BD0C13f6C3F66bb95C79DA",
        "symbol": "PEAR",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xA5beB85e5F82419Ab6BD0C13f6C3F66bb95C79DA.png"
    },
    {
        "chainId": 369,
        "name": "toospooky",
        "address": "0x4Aeb2D80f7A3d310072F0fCAf13B1E943B49b138",
        "symbol": "SPKY",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x4Aeb2D80f7A3d310072F0fCAf13B1E943B49b138.png"
    },
    {
        "chainId": 369,
        "name": "Lunch Money",
        "address": "0x1F5E09CA8164d33d3923ec89c76620B15c51C25B",
        "symbol": "LUNCH",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x1F5E09CA8164d33d3923ec89c76620B15c51C25B.png"
    },
    {
        "chainId": 369,
        "name": "Solid X",
        "address": "0x8Da17Db850315A34532108f0f5458fc0401525f6",
        "symbol": "SOLIDX",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x8Da17Db850315A34532108f0f5458fc0401525f6.png"
    },
    {
        "chainId": 369,
        "name": "PermaGIFF",
        "address": "0x8fC70fd5F10Cd5494EB369b0737CefD22eB33F17",
        "symbol": "pGIFF",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x8fC70fd5F10Cd5494EB369b0737CefD22eB33F17.png"
    },
    {
        "chainId": 369,
        "name": "DaiHard",
        "address": "0xB6Bad00525221EB28Eb911a0B1162a0709b4CE57",
        "symbol": "HARD",
        "decimals": 9,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xB6Bad00525221EB28Eb911a0B1162a0709b4CE57.png"
    },
    {
        "chainId": 369,
        "name": "ICARUS",
        "address": "0x8c4a50c87e348f602ac6a59f4Da857ee23307a42",
        "symbol": "ICARUS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x8c4a50c87e348f602ac6a59f4Da857ee23307a42.png"
    },
    {
        "chainId": 369,
        "name": "Chiitan",
        "address": "0xabeb72F153e050B3F8cCa3DD93fe1eEaD51123DB",
        "symbol": "CHIITAN",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xabeb72F153e050B3F8cCa3DD93fe1eEaD51123DB.png"
    },
    {
        "chainId": 369,
        "name": "FUGAZI",
        "address": "0x80028eDf22a39E7DE07F4b6D9a559420e40b8761",
        "symbol": "FGZ",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x80028eDf22a39E7DE07F4b6D9a559420e40b8761.png"
    },
    {
        "chainId": 369,
        "name": "Hammer Time",
        "address": "0x0767ed257BeEE2F4659e31Ab80AEE3FD2D5Cd81b",
        "symbol": "DISCOVERY",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x0767ed257BeEE2F4659e31Ab80AEE3FD2D5Cd81b.png"
    },
    {
        "chainId": 369,
        "name": "MetaTreasure",
        "address": "0x8aB5BAB83E62D647aF74631479885556Ee9f3410",
        "symbol": "MTT",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x8aB5BAB83E62D647aF74631479885556Ee9f3410.png"
    },
    {
        "chainId": 369,
        "name": "LEVEL",
        "address": "0x569D4018E8a5B869b57df1a0A5C7B4E71aF29656",
        "symbol": "LVL",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x569D4018E8a5B869b57df1a0A5C7B4E71aF29656.png"
    },
    {
        "chainId": 369,
        "name": "Cream",
        "address": "0x2ba592F78dB6436527729929AAf6c908497cB200",
        "symbol": "CREAM",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x2ba592F78dB6436527729929AAf6c908497cB200.png"
    },
    {
        "chainId": 369,
        "name": "Florida Fruit Rat",
        "address": "0x14B02AFF4B105d18c90472EF574AcC58D9994D1D",
        "symbol": "FRUIT",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x14B02AFF4B105d18c90472EF574AcC58D9994D1D.png"
    },
    {
        "chainId": 369,
        "name": "Banana Republic",
        "address": "0x74D98E37132dF921dF38c5A2Ae8748aDbab63238",
        "symbol": "Nanana",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x74D98E37132dF921dF38c5A2Ae8748aDbab63238.png"
    },
    {
        "chainId": 369,
        "name": "SUN Minimeal SOIL",
        "address": "0xbd63FA573A120013804e51B46C56F9b3e490f53C",
        "symbol": "SOIL",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xbd63FA573A120013804e51B46C56F9b3e490f53C.png"
    },
    {
        "chainId": 369,
        "name": "ACCOUNT",
        "address": "0x283a7e68DBB4d26Cb3878CA9084ed3d0e45cF5C5",
        "symbol": "ACCOUNT",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x283a7e68DBB4d26Cb3878CA9084ed3d0e45cF5C5.png"
    },
    {
        "chainId": 369,
        "name": "FRESH START SHOWER",
        "address": "0x4B8dA1baCdc416A1Cc339F462e2DE97A4D7cE891",
        "symbol": "FSS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x4B8dA1baCdc416A1Cc339F462e2DE97A4D7cE891.png"
    },
    {
        "chainId": 369,
        "name": "BROmance",
        "address": "0x401464296A7e0cd14D85AB6baF0Dc91B5ad5Ad1b",
        "symbol": "BRO",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x401464296A7e0cd14D85AB6baF0Dc91B5ad5Ad1b.png"
    },
    {
        "chainId": 369,
        "name": "WINGS",
        "address": "0xe991E9A1090E707206e12561eB271712B1A20Ee4",
        "symbol": "WINGS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xe991E9A1090E707206e12561eB271712B1A20Ee4.png"
    },
    {
        "chainId": 369,
        "name": "SCUBA STEVE",
        "address": "0x5FE90464eD06B809D3f8888aD12e98346E409d4D",
        "symbol": "TEVE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x5FE90464eD06B809D3f8888aD12e98346E409d4D.png"
    },
    {
        "chainId": 369,
        "name": "UFO",
        "address": "0x456548A9B56eFBbD89Ca0309edd17a9E20b04018",
        "symbol": "UFO",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x456548A9B56eFBbD89Ca0309edd17a9E20b04018.png"
    },
    {
        "chainId": 369,
        "name": "PEDRO",
        "address": "0xE6A811b5D0590cA747eefeC84EEB8de9FbE4449c",
        "symbol": "PEDRO",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xE6A811b5D0590cA747eefeC84EEB8de9FbE4449c.png"
    },
    {
        "chainId": 369,
        "name": "Freedom of Peach",
        "address": "0x3cC6704b0902475587363DEfbD6dAb2ec0581628",
        "symbol": "PEACH",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x3cC6704b0902475587363DEfbD6dAb2ec0581628.png"
    },
    {
        "chainId": 369,
        "name": "PenPineappleApplePen",
        "address": "0x8b659DDc0289eD8E5E463254B34ffc7CA3DF1DEC",
        "symbol": "PPAP",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x8b659DDc0289eD8E5E463254B34ffc7CA3DF1DEC.png"
    },
    {
        "chainId": 369,
        "name": "Icosa Burn",
        "address": "0xBd2826B7823537fcD30D738aBe4250AD6262209c",
        "symbol": "iBurn",
        "decimals": 9,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xBd2826B7823537fcD30D738aBe4250AD6262209c.png"
    },
    {
        "chainId": 369,
        "name": "Gnosis on Pulsechain",
        "address": "0x6810e776880C02933D47DB1b9fc05908e5386b96",
        "symbol": "pGNO",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6810e776880C02933D47DB1b9fc05908e5386b96.png"
    },
    {
        "chainId": 369,
        "name": "Pulse Drip",
        "address": "0xeB2CEed77147893Ba8B250c796c2d4EF02a72B68",
        "symbol": "PDRIP",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xeB2CEed77147893Ba8B250c796c2d4EF02a72B68.png"
    },
    {
        "chainId": 369,
        "name": "GameStop",
        "address": "0xDd199016942596Ad07B0aC5Cb167121F4D709d56",
        "symbol": "GME",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xDd199016942596Ad07B0aC5Cb167121F4D709d56.png"
    },
    {
        "chainId": 369,
        "name": "Orange Man Good",
        "address": "0xf21aeE14137E9bC4B3D5170300dde849f7fE2D85",
        "symbol": "OMG",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xf21aeE14137E9bC4B3D5170300dde849f7fE2D85.png"
    },
    {
        "chainId": 369,
        "name": "BABY GIFF",
        "address": "0x32151909F971534de577d86E5346e45d1D9873d9",
        "symbol": "bGIFF",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x32151909F971534de577d86E5346e45d1D9873d9.png"
    },
    {
        "chainId": 369,
        "name": "GAME",
        "address": "0xc13A1f27ca24523cfe4C817eD7FF752783fBCd19",
        "symbol": "GAME",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xc13A1f27ca24523cfe4C817eD7FF752783fBCd19.png"
    },
    {
        "chainId": 369,
        "name": "DickWifPump",
        "address": "0x424E38032E9D3BfD0A72f837B4d930A6831D11c6",
        "symbol": "DWP",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x424E38032E9D3BfD0A72f837B4d930A6831D11c6.png"
    },
    {
        "chainId": 369,
        "name": "New York City Pizza Rat",
        "address": "0xaC9052cb220951c3CCA0Beb4C084A7D4fd2e3428",
        "symbol": "PIZZA",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xaC9052cb220951c3CCA0Beb4C084A7D4fd2e3428.png"
    },
    {
        "chainId": 369,
        "name": "MatiAllin",
        "address": "0xC697E0bB8ac6D1CFd928bca3E43CC64e2190e828",
        "symbol": "MATI",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xC697E0bB8ac6D1CFd928bca3E43CC64e2190e828.png"
    },
    {
        "chainId": 369,
        "name": "LiquidHEX",
        "address": "0xa73f450E3f17468A64BFdD222b099857Db76634d",
        "symbol": "LHEX",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xa73f450E3f17468A64BFdD222b099857Db76634d.png"
    },
    {
        "chainId": 369,
        "name": "Mega Milk",
        "address": "0x1d98844528313Ed4fC743Cc106C15aee07C2072F",
        "symbol": "MILK",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x1d98844528313Ed4fC743Cc106C15aee07C2072F.png"
    },
    {
        "chainId": 369,
        "name": "PIKA to PIKO",
        "address": "0x0A0F70B227f782f2CeAD75554781AF45a620A296",
        "symbol": "PIKA",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x0A0F70B227f782f2CeAD75554781AF45a620A296.png"
    },
    {
        "chainId": 369,
        "name": "Pool Token",
        "address": "0x96c91022A7CB49B41Cb2262E9fB560D863b7389e",
        "symbol": "POOL",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x96c91022A7CB49B41Cb2262E9fB560D863b7389e.png"
    },
    {
        "chainId": 369,
        "name": "Pulse Zen",
        "address": "0x5a24D7129B6f3FcAd2220296df28911880AD22B0",
        "symbol": "PZEN",
        "decimals": 9,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x5a24D7129B6f3FcAd2220296df28911880AD22B0.png"
    },
    {
        "chainId": 369,
        "name": "Tellor Tributes on Pulsechain",
        "address": "0x88dF592F8eb5D7Bd38bFeF7dEb0fBc02cf3778a0",
        "symbol": "pTRB",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x88dF592F8eb5D7Bd38bFeF7dEb0fBc02cf3778a0.png"
    },
    {
        "chainId": 369,
        "name": "LQTY on Pulsechain",
        "address": "0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D",
        "symbol": "pLQTY",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D.png"
    },
    {
        "chainId": 369,
        "name": "Uniswap on Pulsechain",
        "address": "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
        "symbol": "pUNI",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984.png"
    },
    {
        "chainId": 369,
        "name": "Binance USD on Pulsechain",
        "address": "0x4Fabb145d64652a948d72533023f6E7A623C7C53",
        "symbol": "pBUSD",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x4Fabb145d64652a948d72533023f6E7A623C7C53.png"
    },
    {
        "chainId": 369,
        "name": "Content Reward Token",
        "address": "0xb528a9DB27A74dB802C74D0CCc40657efE5F0A45",
        "symbol": "SAVVA",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xb528a9DB27A74dB802C74D0CCc40657efE5F0A45.png"
    },
    {
        "chainId": 369,
        "name": "ENKI",
        "address": "0x0bC1e003e2A3CE1428Ec1c3B846E99EbC246BAa7",
        "symbol": "ENKI",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x0bC1e003e2A3CE1428Ec1c3B846E99EbC246BAa7.png"
    },
    {
        "chainId": 369,
        "name": "MAFIA",
        "address": "0xa27aDe5806Ded801b93499C6fA23cc8dC9AC55EA",
        "symbol": "MAFIA",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xa27aDe5806Ded801b93499C6fA23cc8dC9AC55EA.png"
    },
    {
        "chainId": 369,
        "name": "HEX1 Token",
        "address": "0x298978f9B59A4BF9c08C114Fb6848fade7Be7E18",
        "symbol": "HEX1",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x298978f9B59A4BF9c08C114Fb6848fade7Be7E18.png"
    },
    {
        "chainId": 369,
        "name": "HEXIT Token",
        "address": "0x8d4D6aa8339dB0252dc92957544fe6931e0826Db",
        "symbol": "HEXIT",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x8d4D6aa8339dB0252dc92957544fe6931e0826Db.png"
    },
    {
        "chainId": 369,
        "name": "VETERANS",
        "address": "0x4013abBf94A745EfA7cc848989Ee83424A770060",
        "symbol": "VETS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x4013abBf94A745EfA7cc848989Ee83424A770060.png"
    },
    {
        "chainId": 369,
        "name": "Leonidas",
        "address": "0x165D605DAEAD3ee97b887CAf30e2dF673646d1F4",
        "symbol": "Leonidas",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x165D605DAEAD3ee97b887CAf30e2dF673646d1F4.png"
    },
    {
        "chainId": 369,
        "name": "StackedItalian",
        "address": "0x67d8954C2B7386c8Dbf6936Cc2355bA2227F0a8f",
        "symbol": "Stack",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x67d8954C2B7386c8Dbf6936Cc2355bA2227F0a8f.png"
    },
    {
        "chainId": 369,
        "name": "Fibocoin",
        "address": "0xF882BC48d989Ca1cA55a268701BfA3619B0a3Fd4",
        "symbol": "FIB",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xF882BC48d989Ca1cA55a268701BfA3619B0a3Fd4.png"
    },
    {
        "chainId": 369,
        "name": "Pulse TV",
        "address": "0xA5AC6346077aa95095D34AEBFbcd61C367A08B2f",
        "symbol": "PTV",
        "decimals": 4,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xA5AC6346077aa95095D34AEBFbcd61C367A08B2f.png"
    },
    {
        "chainId": 369,
        "name": "WIN",
        "address": "0xFeAC4699AcFC80BA888FE20235c3B381d9af7C30",
        "symbol": "WIN",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xFeAC4699AcFC80BA888FE20235c3B381d9af7C30.png"
    },
    {
        "chainId": 369,
        "name": "REFLUX",
        "address": "0xF876BDf9D6403AA7D5bF7F523E8f440A841CC596",
        "symbol": "RFX",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xF876BDf9D6403AA7D5bF7F523E8f440A841CC596.png"
    },
    {
        "chainId": 369,
        "name": "Bitcoin Cash",
        "address": "0xD4e685ecD1C177A5D9661cF675309E5D00c2e08a",
        "symbol": "BCH",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xD4e685ecD1C177A5D9661cF675309E5D00c2e08a.png"
    },
    {
        "chainId": 369,
        "name": "GIGA CHAD",
        "address": "0xCB43bc226386f8b9d63879ee3A4C5b32E6516054",
        "symbol": "CHAD",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xCB43bc226386f8b9d63879ee3A4C5b32E6516054.png"
    },
    {
        "chainId": 369,
        "name": "CAMEL CLAN",
        "address": "0xC1967c5a0cedc577D9017D2465bC0b0c55eAFE49",
        "symbol": "CAMEL",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xC1967c5a0cedc577D9017D2465bC0b0c55eAFE49.png"
    },
    {
        "chainId": 369,
        "name": "KING POOIE",
        "address": "0x3653FFa4c863585F8303BD649BcF934C621EE30C",
        "symbol": "KING2",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x3653FFa4c863585F8303BD649BcF934C621EE30C.png"
    },
    {
        "chainId": 369,
        "name": "Ditto",
        "address": "0xc438437218009EDD656d319689c902aE56b4b96F",
        "symbol": "DTO",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xc438437218009EDD656d319689c902aE56b4b96F.png"
    },
    {
        "chainId": 369,
        "name": "ChuckNorris",
        "address": "0x1Cf43d56cF32e754FfC894c2b0587d8BC9035952",
        "symbol": "INCENTIVE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x1Cf43d56cF32e754FfC894c2b0587d8BC9035952.png"
    },
    {
        "chainId": 369,
        "name": "PeterParker",
        "address": "0x54E51Cfa1CF14cB03A7eF172439fEca8804dBE1D",
        "symbol": "PULSECHAIN",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x54E51Cfa1CF14cB03A7eF172439fEca8804dBE1D.png"
    },
    {
        "chainId": 369,
        "name": "Mudkip",
        "address": "0x95032Be41FfD6fea41781447332B5F7b1542D03d",
        "symbol": "Mudkip",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x95032Be41FfD6fea41781447332B5F7b1542D03d.png"
    },
    {
        "chainId": 369,
        "name": "AFFECTION",
        "address": "0x24F0154C1dCe548AdF15da2098Fdd8B8A3B8151D",
        "symbol": "AFFECTION",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x24F0154C1dCe548AdF15da2098Fdd8B8A3B8151D.png"
    },
    {
        "chainId": 369,
        "name": "X Protocol Token",
        "address": "0xA6C4790cc7Aa22CA27327Cb83276F2aBD687B55b",
        "symbol": "X",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xA6C4790cc7Aa22CA27327Cb83276F2aBD687B55b.png"
    },
    {
        "chainId": 369,
        "name": "Shocker",
        "address": "0x97F50E6bAAA852701D2fb9d7542C87ac7cD8262D",
        "symbol": "SHKR",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x97F50E6bAAA852701D2fb9d7542C87ac7cD8262D.png"
    },
    {
        "chainId": 369,
        "name": "JUPITER",
        "address": "0x9Dc1684Fa60458faf59Af2a7538FF9bd59a62BD6",
        "symbol": "JUPITER",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x9Dc1684Fa60458faf59Af2a7538FF9bd59a62BD6.png"
    },
    {
        "chainId": 369,
        "name": "6 Tons of Digital Gold",
        "address": "0x4FC0C8a7636cfE551bb077BA928b4E9d59b02DC2",
        "symbol": "GOLD6T",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x4FC0C8a7636cfE551bb077BA928b4E9d59b02DC2.png"
    },
    {
        "chainId": 369,
        "name": "SOUL USD",
        "address": "0x8C9c31c740BA466BF2218dA2a78D40B123FC9495",
        "symbol": "SUSD",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x8C9c31c740BA466BF2218dA2a78D40B123FC9495.png"
    },
    {
        "chainId": 369,
        "name": "SOULS",
        "address": "0x3B5eBC98eD7a796A60eDA15b54Cb084629134573",
        "symbol": "SOULS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x3B5eBC98eD7a796A60eDA15b54Cb084629134573.png"
    },
    {
        "chainId": 369,
        "name": "FREE SOUL",
        "address": "0x23f2621d0C392d1dD4E2840416d651536dA64D4A",
        "symbol": "FREE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x23f2621d0C392d1dD4E2840416d651536dA64D4A.png"
    },
    {
        "chainId": 369,
        "name": "FREE PALESTINE",
        "address": "0xde3bab90cA73D22C77050153f0bDab4c516C5552",
        "symbol": "FREE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xde3bab90cA73D22C77050153f0bDab4c516C5552.png"
    },
    {
        "chainId": 369,
        "name": "My Portfolio",
        "address": "0xD29582F42C6Aa7Bf4133F0CEda65de9c5fBEd338",
        "symbol": "WRECKED",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xD29582F42C6Aa7Bf4133F0CEda65de9c5fBEd338.png"
    },
    {
        "chainId": 369,
        "name": "HACHIKO",
        "address": "0xAf5ec50cECCc4acb41204525019F531B2A55675c",
        "symbol": "HATCHI",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xAf5ec50cECCc4acb41204525019F531B2A55675c.png"
    },
    {
        "chainId": 369,
        "name": "Charmander",
        "address": "0xa0381b8deB04D29FB01de3050B54c226f0BFcfB1",
        "symbol": "Charm",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xa0381b8deB04D29FB01de3050B54c226f0BFcfB1.png"
    },
    {
        "chainId": 369,
        "name": "Meowth",
        "address": "0x7cbEd98f3679795fc8Cd8594b98bE77575eDE156",
        "symbol": "MEOWTH",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x7cbEd98f3679795fc8Cd8594b98bE77575eDE156.png"
    },
    {
        "chainId": 369,
        "name": "Snorlax",
        "address": "0xc1042c35A077F5c77e0FDec0E5Ea70E80b016d78",
        "symbol": "Snorlax",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xc1042c35A077F5c77e0FDec0E5Ea70E80b016d78.png"
    },
    {
        "chainId": 369,
        "name": "DOMESHOT",
        "address": "0x23c9945687c49eB8E65A2Fd690E1D92fD0c3efE7",
        "symbol": "DOME",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x23c9945687c49eB8E65A2Fd690E1D92fD0c3efE7.png"
    },
    {
        "chainId": 369,
        "name": "Actuator",
        "address": "0x85DF7cE20A4CE0cF859804b45cB540FFE42074Da",
        "symbol": "ACTR",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x85DF7cE20A4CE0cF859804b45cB540FFE42074Da.png"
    },
    {
        "chainId": 369,
        "name": "KUMAMON",
        "address": "0x4eF90d0a9b107DFf6E916102C4DaF3d0A564b577",
        "symbol": "KUMAMON",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x4eF90d0a9b107DFf6E916102C4DaF3d0A564b577.png"
    },
    {
        "chainId": 369,
        "name": "Jigglypuff",
        "address": "0x2dA60FA8D9d8481Df1CbEF487DA8Bc70dE81b3Cc",
        "symbol": "PUFF",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x2dA60FA8D9d8481Df1CbEF487DA8Bc70dE81b3Cc.png"
    },
    {
        "chainId": 369,
        "name": "GENGAR",
        "address": "0x8e60Dc40D25565867da4e0cD9c55411043F14c19",
        "symbol": "GENGAR",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x8e60Dc40D25565867da4e0cD9c55411043F14c19.png"
    },
    {
        "chainId": 369,
        "name": "Magikarp",
        "address": "0x0c6861A673A10C272bEa7947De5E60ab44B6BAc6",
        "symbol": "RAGE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x0c6861A673A10C272bEa7947De5E60ab44B6BAc6.png"
    },
    {
        "chainId": 369,
        "name": "Pulsar from Ethereum",
        "address": "0x69C96Bb512A386a538ab52C87F34aCAf9c76D05a",
        "symbol": "PULSAR",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x69C96Bb512A386a538ab52C87F34aCAf9c76D05a.png"
    },
    {
        "chainId": 369,
        "name": "TITAN X from Ethereum",
        "address": "0xBE3381E831C035169B92EF0Cc4759C570528577d",
        "symbol": "TITANX",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xBE3381E831C035169B92EF0Cc4759C570528577d.png"
    },
    {
        "chainId": 369,
        "name": "HEX Time Token 3000",
        "address": "0xE9E1340A2b31d5D2a2dB28FB854a794E106b430a",
        "symbol": "HTT3000",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xE9E1340A2b31d5D2a2dB28FB854a794E106b430a.png"
    },
    {
        "chainId": 369,
        "name": "HEX Time Token 5000",
        "address": "0xE2D03779147A32064511dd2b9D37F66f3EeFAd7C",
        "symbol": "HTT5000",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xE2D03779147A32064511dd2b9D37F66f3EeFAd7C.png"
    },
    {
        "chainId": 369,
        "name": "HEX Time Token 7000",
        "address": "0x47810bb3ECDc6b080CeB2d39E769F21Ff14AB7E9",
        "symbol": "HTT7000",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x47810bb3ECDc6b080CeB2d39E769F21Ff14AB7E9.png"
    },
    {
        "chainId": 369,
        "name": "HEX Time Token 4000",
        "address": "0x3Cf372aA6aAa46eDc4B8da86294deC0DDecED632",
        "symbol": "HTT4000",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x3Cf372aA6aAa46eDc4B8da86294deC0DDecED632.png"
    },
    {
        "chainId": 369,
        "name": "HEX Time Token 6000",
        "address": "0xcdBFaf528c7CeA55d0AEbdB93C218D6f23B24af3",
        "symbol": "HTT6000",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xcdBFaf528c7CeA55d0AEbdB93C218D6f23B24af3.png"
    },
    {
        "chainId": 369,
        "name": "Pulsican Store",
        "address": "0x1BC0CE24e87d998b96b42f0F8f70A5aa8d637a04",
        "symbol": "PLSS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x1BC0CE24e87d998b96b42f0F8f70A5aa8d637a04.png"
    },
    {
        "chainId": 369,
        "name": "Pepechu",
        "address": "0x4F0a3F5b40C509402930B139EaF006AFfBF75aDb",
        "symbol": "PEPU",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x4F0a3F5b40C509402930B139EaF006AFfBF75aDb.png"
    },
    {
        "chainId": 369,
        "name": "Bulbasaur",
        "address": "0xE37747c9f3e09fCbBC9615A4Cd12C97E7BB50E34",
        "symbol": "Bulba",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xE37747c9f3e09fCbBC9615A4Cd12C97E7BB50E34.png"
    },
    {
        "chainId": 369,
        "name": "TRUMP Shooses",
        "address": "0xD010BF67fC59AA9e440125990de23AAb91B2e5b1",
        "symbol": "SHOOS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xD010BF67fC59AA9e440125990de23AAb91B2e5b1.png"
    },
    {
        "chainId": 369,
        "name": "HeartWifDog",
        "address": "0x16757fa456F06AAB7aDa2Be7a5FF47fef96572DC",
        "symbol": "HOG",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x16757fa456F06AAB7aDa2Be7a5FF47fef96572DC.png"
    },
    {
        "chainId": 369,
        "name": "SPX6900",
        "address": "0xdE33300e2Ec7A5b863d39eE7dDC02e58FB021F45",
        "symbol": "SPX",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xdE33300e2Ec7A5b863d39eE7dDC02e58FB021F45.png"
    },
    {
        "chainId": 369,
        "name": "Squirrel Wif Nut",
        "address": "0x874e3F27140FCB7cd734df9758552f36f1AC5fcF",
        "symbol": "NUTS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x874e3F27140FCB7cd734df9758552f36f1AC5fcF.png"
    },
    {
        "chainId": 369,
        "name": "Judge Aunty Carol",
        "address": "0x51a05d2df463540c2176bADdFA946fAA0A3B5dC6",
        "symbol": "Aunty",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x51a05d2df463540c2176bADdFA946fAA0A3B5dC6.png"
    },
    {
        "chainId": 369,
        "name": "Bullseye Bot Token",
        "address": "0xeAb7c22B8F5111559A2c2B1A3402d3FC713CAc27",
        "symbol": "BLSEYE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xeAb7c22B8F5111559A2c2B1A3402d3FC713CAc27.png"
    },
    {
        "chainId": 369,
        "name": "XBURN.win",
        "address": "0x6518dD379F02DDDb65C027fE8b4042E91337ba62",
        "symbol": "XBURN",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6518dD379F02DDDb65C027fE8b4042E91337ba62.png"
    },
    {
        "chainId": 369,
        "name": "Finvesta",
        "address": "0x1C81b4358246d3088Ab4361aB755F3D8D4dd62d2",
        "symbol": "Finvesta",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x1C81b4358246d3088Ab4361aB755F3D8D4dd62d2.png"
    },
    {
        "chainId": 369,
        "name": "Son Goku",
        "address": "0x1eA85D477b8A523a813326eC29Ea14784339E28d",
        "symbol": "GOKU",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x1eA85D477b8A523a813326eC29Ea14784339E28d.png"
    },
    {
        "chainId": 369,
        "name": "Growth",
        "address": "0x09e64c2B61a5f1690Ee6fbeD9baf5D6990F8dFd0",
        "symbol": "GRO",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x09e64c2B61a5f1690Ee6fbeD9baf5D6990F8dFd0.png"
    },
    {
        "chainId": 369,
        "name": "HEX5555",
        "address": "0x04A3f80869eDD465B79bD8868Bde1a843c521b80",
        "symbol": "HEX",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x04A3f80869eDD465B79bD8868Bde1a843c521b80.png"
    },
    {
        "chainId": 369,
        "name": "Department of Government Efficiency",
        "address": "0x572Cd3d0e7532439eeAa8cF4C129D2264B6e515f",
        "symbol": "DOGE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x572Cd3d0e7532439eeAa8cF4C129D2264B6e515f.png"
    },
    {
        "chainId": 369,
        "name": "Pulsechain Capital",
        "address": "0xfE2895A52271adA8227f5439A20096217A9098b1",
        "symbol": "PCAP",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xfE2895A52271adA8227f5439A20096217A9098b1.png"
    },
    {
        "chainId": 369,
        "name": "Stock Token",
        "address": "0x7329F6d1d72fCB7A3623504cadE84915b021ba3c",
        "symbol": "STOCK",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x7329F6d1d72fCB7A3623504cadE84915b021ba3c.png"
    },
    {
        "chainId": 369,
        "name": "The QuadFather",
        "address": "0xB2fbC6E798EF33342f6810CEB32AC498B6563082",
        "symbol": "QUAD",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xB2fbC6E798EF33342f6810CEB32AC498B6563082.png"
    },
    {
        "chainId": 369,
        "name": "XUSD Vibratile Asset",
        "address": "0xbbeA78397d4d4590882EFcc4820f03074aB2AB29",
        "symbol": "XUSD",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xbbeA78397d4d4590882EFcc4820f03074aB2AB29.png"
    },
    {
        "chainId": 369,
        "name": "SPONGE on PULSE V2",
        "address": "0x196dD891e009f9ebE441103420A07326c4a33cba",
        "symbol": "SPONGE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x196dD891e009f9ebE441103420A07326c4a33cba.png"
    },
    {
        "chainId": 369,
        "name": "Dai Niro",
        "address": "0x0297a4d78dA1dbd8C1ce1FF4d90F1cb22C3ec12A",
        "symbol": "Niro",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x0297a4d78dA1dbd8C1ce1FF4d90F1cb22C3ec12A.png"
    },
    {
        "chainId": 369,
        "name": "Vaultiano",
        "address": "0xB9Cd6E3f7B4539795cB51E9C02cb7ba1A2E277d1",
        "symbol": "VAULT",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xB9Cd6E3f7B4539795cB51E9C02cb7ba1A2E277d1.png"
    },
    {
        "chainId": 369,
        "name": "Vouch Staked PLS",
        "address": "0x79BB3A0Ee435f957ce4f54eE8c3CFADc7278da0C",
        "symbol": "vPLS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x79BB3A0Ee435f957ce4f54eE8c3CFADc7278da0C.png"
    },
    {
        "chainId": 369,
        "name": "AxisAlive",
        "address": "0xB0eBAf9378d6E7531ba09403A12636947CC2f84b",
        "symbol": "ALIVE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xB0eBAf9378d6E7531ba09403A12636947CC2f84b.png"
    },
    {
        "chainId": 369,
        "name": "SoftTastyDonut",
        "address": "0x55f49Fe677d104D0141CEF3EcFE4FCcA892D4aa9",
        "symbol": "STD",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x55f49Fe677d104D0141CEF3EcFE4FCcA892D4aa9.png"
    },
    {
        "chainId": 369,
        "name": "10x That Shit",
        "address": "0xdA1dAfB686959F1410e8A0863ebCEA02Fa605933",
        "symbol": "10x",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xdA1dAfB686959F1410e8A0863ebCEA02Fa605933.png"
    },
    {
        "chainId": 369,
        "name": "QUESO from Burritos.Cash",
        "address": "0xef6570621B4E7aD12F60ECE4FC09608769cDecD9",
        "symbol": "QUESO",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xef6570621B4E7aD12F60ECE4FC09608769cDecD9.png"
    },
    {
        "chainId": 369,
        "name": "PulseDogElon",
        "address": "0xe8CB0509811dAd76e971bAe0D58a813A4B826210",
        "symbol": "PELON",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xe8CB0509811dAd76e971bAe0D58a813A4B826210.png"
    },
    {
        "chainId": 369,
        "name": "In The Know",
        "address": "0x9DC72e4AD4d11841993F6c0a087F5B9fb458aA7C",
        "symbol": "GBABY",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x9DC72e4AD4d11841993F6c0a087F5B9fb458aA7C.png"
    },
    {
        "chainId": 369,
        "name": "HarryPotterObamaSonic10Inu",
        "address": "0x72e4f9F808C49A2a61dE9C5896298920Dc4EEEa9",
        "symbol": "BITCOIN",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x72e4f9F808C49A2a61dE9C5896298920Dc4EEEa9.png"
    },
    {
        "chainId": 369,
        "name": "BriBerry Governance Token",
        "address": "0x08C26D39E9cD2175401F9115A23580cB4A4C935a",
        "symbol": "BRIBE",
        "decimals": 0,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x08C26D39E9cD2175401F9115A23580cB4A4C935a.png"
    },
    {
        "chainId": 369,
        "name": "Eevee",
        "address": "0x64f4EE0BDf92BcD7ED332eC6675726E9c0D06F8F",
        "symbol": "EEVEE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x64f4EE0BDf92BcD7ED332eC6675726E9c0D06F8F.png"
    },
    {
        "chainId": 369,
        "name": "MAGIX",
        "address": "0xFC3824E8d68988D66c23baeD7bA094D8B0DBd9a6",
        "symbol": "MAGIX",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xFC3824E8d68988D66c23baeD7bA094D8B0DBd9a6.png"
    },
    {
        "chainId": 369,
        "name": "Peezy",
        "address": "0x698Cb3223D8eB1A3D9908e304775118DF4F81933",
        "symbol": "PEEZY",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x698Cb3223D8eB1A3D9908e304775118DF4F81933.png"
    },
    {
        "chainId": 369,
        "name": "FOX",
        "address": "0xc770EEfAd204B5180dF6a14Ee197D99d808ee52d",
        "symbol": "pFOX",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xc770EEfAd204B5180dF6a14Ee197D99d808ee52d.png"
    },
    {
        "chainId": 369,
        "name": "KISHKA",
        "address": "0x2dd40F954093A9C2D67EBb5687Df9292Dac335F3",
        "symbol": "KISHKA",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x2dd40F954093A9C2D67EBb5687Df9292Dac335F3.png"
    },
    {
        "chainId": 369,
        "name": "Gelato",
        "address": "0x616cb6a245Ed4c11216Ec58D10B6A2E87271845d",
        "symbol": "GEL",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x616cb6a245Ed4c11216Ec58D10B6A2E87271845d.png"
    },
    {
        "chainId": 369,
        "name": "Lady Gaga",
        "address": "0x9fC97f73A610318FEe90a8BdfcC2AD08e2E884DD",
        "symbol": "GAGA",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x9fC97f73A610318FEe90a8BdfcC2AD08e2E884DD.png"
    },
    {
        "chainId": 369,
        "name": "SIMP",
        "address": "0xADBD09Faf339BD18d00430Be1c2cba6c1119df1E",
        "symbol": "IMP",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xADBD09Faf339BD18d00430Be1c2cba6c1119df1E.png"
    },
    {
        "chainId": 369,
        "name": "PLSPUPPY",
        "address": "0xe3B3f5F95d263edc6A5e3D4b7314728A390a4342",
        "symbol": "PLSPUP",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xe3B3f5F95d263edc6A5e3D4b7314728A390a4342.png"
    },
    {
        "chainId": 369,
        "name": "pVOLT",
        "address": "0x74758472AddC95944769E8aDac07E391c31cAc82",
        "symbol": "pVOLT",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x74758472AddC95944769E8aDac07E391c31cAc82.png"
    },
    {
        "chainId": 369,
        "name": "Genesis P-Orridge Coin",
        "address": "0xc7eB14e178220E84530748a71b91F07c3545dE50",
        "symbol": "GENESIS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xc7eB14e178220E84530748a71b91F07c3545dE50.png"
    },
    {
        "chainId": 369,
        "name": "Janus",
        "address": "0xd5A96B6ACa28302CF1B0F860673851705D25667e",
        "symbol": "JNS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xd5A96B6ACa28302CF1B0F860673851705D25667e.png"
    },
    {
        "chainId": 369,
        "name": "Dark",
        "address": "0x1578F4De7fCb3Ac9e8925ac690228EDcA3BBc7c5",
        "symbol": "DARK",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x1578F4De7fCb3Ac9e8925ac690228EDcA3BBc7c5.png"
    },
    {
        "chainId": 369,
        "name": "PulseLitecoin",
        "address": "0x68eA849F92998D54555B33F45825c42Ee56866Fb",
        "symbol": "pLTC",
        "decimals": 12,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x68eA849F92998D54555B33F45825c42Ee56866Fb.png"
    },
    {
        "chainId": 369,
        "name": "One Click Away",
        "address": "0xa17ff0061c1E3161fe281C5FBa23B48b23ce9636",
        "symbol": "CLICK",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xa17ff0061c1E3161fe281C5FBa23B48b23ce9636.png"
    },
    {
        "chainId": 369,
        "name": "ETHTC",
        "address": "0xB6FDD8A5b6069De409288Bc30C69c5856Dc67aC8",
        "symbol": "ETHTC",
        "decimals": 2,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xB6FDD8A5b6069De409288Bc30C69c5856Dc67aC8.png"
    },
    {
        "chainId": 369,
        "name": "Milady",
        "address": "0xD100ecF770dC06D407787c3a991086a6E876Cc17",
        "symbol": "MILADY",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xD100ecF770dC06D407787c3a991086a6E876Cc17.png"
    },
    {
        "chainId": 369,
        "name": "MOST WANTED",
        "address": "0x79FC0E1d3EC00d81E5423DcC01A617b0e1245c2B",
        "symbol": "RICKY",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x79FC0E1d3EC00d81E5423DcC01A617b0e1245c2B.png"
    },
    {
        "chainId": 369,
        "name": "redPILL",
        "address": "0x2f4C121cB612d423d9639dc223576A08098c3537",
        "symbol": "RDPIL",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x2f4C121cB612d423d9639dc223576A08098c3537.png"
    },
    {
        "chainId": 369,
        "name": "ICE KING",
        "address": "0xb33a7a3142532207012F8A88787aB465eAa7FfAc",
        "symbol": "ICE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xb33a7a3142532207012F8A88787aB465eAa7FfAc.png"
    },
    {
        "chainId": 369,
        "name": "Linker",
        "address": "0xA99C95f034Cb10b725724f7679D10DE1748aD8ca",
        "symbol": "LNKR",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xA99C95f034Cb10b725724f7679D10DE1748aD8ca.png"
    },
    {
        "chainId": 369,
        "name": "Project Pi Liquid Staking Token",
        "address": "0x21dCB2c16C3773A565AcB45f6c34348EC78a8385",
        "symbol": "stPLS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x21dCB2c16C3773A565AcB45f6c34348EC78a8385.png"
    },
    {
        "chainId": 369,
        "name": "MICHI",
        "address": "0xdeFB2a9455B2d8f432d8cFe4355e0594787C23D5",
        "symbol": "MICHI",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xdeFB2a9455B2d8f432d8cFe4355e0594787C23D5.png"
    },
    {
        "chainId": 369,
        "name": "Orion Directive",
        "address": "0xd4f6Dfd7dA9731D11B8789226F6d692f02fea16F",
        "symbol": "ORD",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xd4f6Dfd7dA9731D11B8789226F6d692f02fea16F.png"
    },
    {
        "chainId": 369,
        "name": "Knights of the Orion",
        "address": "0xE7308da032326dE7A2a2b80E1131650E845Ab989",
        "symbol": "KORD",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xE7308da032326dE7A2a2b80E1131650E845Ab989.png"
    },
    {
        "chainId": 369,
        "name": "DOMINANCE",
        "address": "0x116D162d729E27E2E1D6478F1d2A8AEd9C7a2beA",
        "symbol": "DOMINANCE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x116D162d729E27E2E1D6478F1d2A8AEd9C7a2beA.png"
    },
    {
        "chainId": 369,
        "name": "GOPUMPME",
        "address": "0x78Ad9dA5d80a08AeDE9B0876B7A8807320DbDc9A",
        "symbol": "PUMP",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x78Ad9dA5d80a08AeDE9B0876B7A8807320DbDc9A.png"
    },
    {
        "chainId": 369,
        "name": "MostWanted",
        "address": "0xe33a5AE21F93aceC5CfC0b7b0FDBB65A0f0Be5cC",
        "symbol": "MOST",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xe33a5AE21F93aceC5CfC0b7b0FDBB65A0f0Be5cC.png"
    },
    {
        "chainId": 369,
        "name": "Trump",
        "address": "0x8cC6d99114Edd628249fAbc8a4d64F9A759a77Bf",
        "symbol": "Trump",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x8cC6d99114Edd628249fAbc8a4d64F9A759a77Bf.png"
    },
    {
        "chainId": 369,
        "name": "PUMP.tires",
        "address": "0xec4252e62C6dE3D655cA9Ce3AfC12E553ebBA274",
        "symbol": "PUMP",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xec4252e62C6dE3D655cA9Ce3AfC12E553ebBA274.png"
    },
    {
        "chainId": 369,
        "name": "Sommi Fan Token",
        "address": "0x6A46d56F9Dd963cEAc7f60aD148d49219CC3b79f",
        "symbol": "FRIENDSHIP",
        "decimals": 9,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6A46d56F9Dd963cEAc7f60aD148d49219CC3b79f.png"
    },
    {
        "chainId": 369,
        "name": "Core Coin",
        "address": "0xEa65cae72a3B4410aa5e9A964860D46AFc885987",
        "symbol": "CORE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xEa65cae72a3B4410aa5e9A964860D46AFc885987.png"
    },
    {
        "chainId": 369,
        "name": "MARS",
        "address": "0x709e07230860FE0543DCBC359Fdf1D1b5eD13305",
        "symbol": "MARS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x709e07230860FE0543DCBC359Fdf1D1b5eD13305.png"
    },
    {
        "chainId": 369,
        "name": "ELON",
        "address": "0x435363A7C8C63057aAD5d9903c154b4d43E00093",
        "symbol": "ELON",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x435363A7C8C63057aAD5d9903c154b4d43E00093.png"
    },
    {
        "chainId": 369,
        "name": "DEGENS RUN THE CHAIN",
        "address": "0xb8A7bC2c6d5C1f28a8a95Dd0E7676611cfF4b075",
        "symbol": "ALMIGHTY",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xb8A7bC2c6d5C1f28a8a95Dd0E7676611cfF4b075.png"
    },
    {
        "chainId": 369,
        "name": "HexO",
        "address": "0x39BcA0fE6Aed637042Ef19f0FdC2F918933C6b97",
        "symbol": "HexO",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x39BcA0fE6Aed637042Ef19f0FdC2F918933C6b97.png"
    },
    {
        "chainId": 369,
        "name": "BABY HACKER",
        "address": "0x253d5EcaE52B6AFEE9aC4C50e6b51FA9e7E6A8Da",
        "symbol": "BABYHACKER",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x253d5EcaE52B6AFEE9aC4C50e6b51FA9e7E6A8Da.png"
    },
    {
        "chainId": 369,
        "name": "DAI from pump.tires",
        "address": "0xf598cB1D27Fb2c5C731F535AD6c1D0ec5EfE1320",
        "symbol": "DAI",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xf598cB1D27Fb2c5C731F535AD6c1D0ec5EfE1320.png"
    },
    {
        "chainId": 369,
        "name": "USDC from pump.tires",
        "address": "0x080f7A005834c84240F25B2Df4AED8236bd57812",
        "symbol": "PumpUSDC",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x080f7A005834c84240F25B2Df4AED8236bd57812.png"
    },
    {
        "chainId": 369,
        "name": "USDT from pump.tires",
        "address": "0x279d6564A78Cc9f126eC630e8a826DD55294f875",
        "symbol": "USDT",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x279d6564A78Cc9f126eC630e8a826DD55294f875.png"
    },
    {
        "chainId": 369,
        "name": "ETH from pump.tires",
        "address": "0xBFcfA52225Baa5feec5fbb54E6458957D53ddD94",
        "symbol": "ETH",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xBFcfA52225Baa5feec5fbb54E6458957D53ddD94.png"
    },
    {
        "chainId": 369,
        "name": "DOGE from pump.tires",
        "address": "0xDDe9164E7E0DA7ae48b58F36B42c1c9f80e7245F",
        "symbol": "DOGE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xDDe9164E7E0DA7ae48b58F36B42c1c9f80e7245F.png"
    },
    {
        "chainId": 369,
        "name": "PEPE from pump.tires",
        "address": "0x1B71505D95Ab3e7234ed2239b8EC7aa65b94ae7B",
        "symbol": "PEPE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x1B71505D95Ab3e7234ed2239b8EC7aa65b94ae7B.png"
    },
    {
        "chainId": 369,
        "name": "Bitcoin from pump.tires",
        "address": "0xF7bf2A938f971D7e4811A1170C43d651d21A0F81",
        "symbol": "BTC",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xF7bf2A938f971D7e4811A1170C43d651d21A0F81.png"
    },
    {
        "chainId": 369,
        "name": "XRP from pump.tires",
        "address": "0x35Cf97eC047F93660C27c21FdD846dEa72bc66D7",
        "symbol": "XRP",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x35Cf97eC047F93660C27c21FdD846dEa72bc66D7.png"
    },
    {
        "chainId": 369,
        "name": "XRP new from pump.tires",
        "address": "0x9Ff4f187D1a41DCD05d6a80c060c6489C132e372",
        "symbol": "XRP",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x9Ff4f187D1a41DCD05d6a80c060c6489C132e372.png"
    },
    {
        "chainId": 369,
        "name": "Solana from pump.tires",
        "address": "0x873301F2B4B83FeaFF04121B68eC9231B29Ce0df",
        "symbol": "SOL",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x873301F2B4B83FeaFF04121B68eC9231B29Ce0df.png"
    },
    {
        "chainId": 369,
        "name": "Cardano from pump.tires",
        "address": "0x4774e075c16989be68C26cC146fE707Ef4393661",
        "symbol": "ADA",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x4774e075c16989be68C26cC146fE707Ef4393661.png"
    },
    {
        "chainId": 369,
        "name": "Tron from pump.tires",
        "address": "0x0392fBD58918E7ECBB2C68f4EBe4e2225C9a6468",
        "symbol": "TRX",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x0392fBD58918E7ECBB2C68f4EBe4e2225C9a6468.png"
    },
    {
        "chainId": 369,
        "name": "PulseX from pump.tires",
        "address": "0xd73731bDA87C3464e76268c094D959c1B35b9bF1",
        "symbol": "PLSX",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xd73731bDA87C3464e76268c094D959c1B35b9bF1.png"
    },
    {
        "chainId": 369,
        "name": "PulseChain from pump.tires",
        "address": "0x260e5dA7eF6E30e0A647d1aDF47628198DCb0709",
        "symbol": "PLS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x260e5dA7eF6E30e0A647d1aDF47628198DCb0709.png"
    },
    {
        "chainId": 369,
        "name": "HEX from pump.tires",
        "address": "0x55C50875e890c7eE5621480baB02511C380E12C6",
        "symbol": "HEX",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x55C50875e890c7eE5621480baB02511C380E12C6.png"
    },
    {
        "chainId": 369,
        "name": "BestEverything",
        "address": "0x84601f4e914E00Dc40296Ac11CdD27926BE319f2",
        "symbol": "BEST",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x84601f4e914E00Dc40296Ac11CdD27926BE319f2.png"
    },
    {
        "chainId": 369,
        "name": "Dick Heart",
        "address": "0xC86E034d7571459C4E7076Ff92b03fD3e3D0CA0C",
        "symbol": "DICK",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xC86E034d7571459C4E7076Ff92b03fD3e3D0CA0C.png"
    },
    {
        "chainId": 369,
        "name": "ApeCoin on Pulsechain",
        "address": "0x4d224452801ACEd8B2F0aebE155379bb5D594381",
        "symbol": "pAPE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x4d224452801ACEd8B2F0aebE155379bb5D594381.png"
    },
    {
        "chainId": 369,
        "name": "Richard Fartcoin",
        "address": "0x6f40B31737c2B9010Ca86C8a04683Dd64527E205",
        "symbol": "Fartcoin",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6f40B31737c2B9010Ca86C8a04683Dd64527E205.png"
    },
    {
        "chainId": 369,
        "name": "DOUBT",
        "address": "0x6ba0876e30CcE2A9AfC4B82D8BD8A8349DF4Ca96",
        "symbol": "DOUBT",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6ba0876e30CcE2A9AfC4B82D8BD8A8349DF4Ca96.png"
    },
    {
        "chainId": 369,
        "name": "ETH TAKEOVER",
        "address": "0x018eDECc388650C1Af0441907e49fE2c75cdbABD",
        "symbol": "CTO",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x018eDECc388650C1Af0441907e49fE2c75cdbABD.png"
    },
    {
        "chainId": 369,
        "name": "JAMES",
        "address": "0x05076bf151AC83680151111027CBfb08cA057a7A",
        "symbol": "JAMES",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x05076bf151AC83680151111027CBfb08cA057a7A.png"
    },
    {
        "chainId": 369,
        "name": "Dark Rock Insiders Fund Trust",
        "address": "0xA9e71e1AcF993F001f734cE849e8E2fec4B6A4Ea",
        "symbol": "DRIFT",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xA9e71e1AcF993F001f734cE849e8E2fec4B6A4Ea.png"
    },
    {
        "chainId": 369,
        "name": "TIRES",
        "address": "0x1039ED7f66Ca06346ecc807985b7262EeEad8e4f",
        "symbol": "TIRES",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x1039ED7f66Ca06346ecc807985b7262EeEad8e4f.png"
    },
    {
        "chainId": 369,
        "name": "dogwifhat from pump.tires",
        "address": "0xcbc9C2666193733BF99ECCAD74b4435eb0DF179A",
        "symbol": "WIF",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xcbc9C2666193733BF99ECCAD74b4435eb0DF179A.png"
    },
    {
        "chainId": 369,
        "name": "Golden Bear",
        "address": "0x24e130bb9c0436FBB840dbE391861bEA45B96991",
        "symbol": "TEDI",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x24e130bb9c0436FBB840dbE391861bEA45B96991.png"
    },
    {
        "chainId": 369,
        "name": "MAGIC CARPET",
        "address": "0x6794E23f0C09e4e54848eDd64502806876d42b0F",
        "symbol": "RIDE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6794E23f0C09e4e54848eDd64502806876d42b0F.png"
    },
    {
        "chainId": 369,
        "name": "Michi",
        "address": "0x4c27CC93603bC1d0913C6aA0100Da49A9D982c38",
        "symbol": "Michi",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x4c27CC93603bC1d0913C6aA0100Da49A9D982c38.png"
    },
    {
        "chainId": 369,
        "name": "The One Meme",
        "address": "0x2012aC87AE6222E5B496d1ba873c6fd79E9c0b7A",
        "symbol": "RING",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x2012aC87AE6222E5B496d1ba873c6fd79E9c0b7A.png"
    },
    {
        "chainId": 369,
        "name": "Eli Porter",
        "address": "0x6f82e6c4747c616d2e57D306f44EFCc206D49858",
        "symbol": "ELI",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6f82e6c4747c616d2e57D306f44EFCc206D49858.png"
    },
    {
        "chainId": 369,
        "name": "Lazy",
        "address": "0x97df6a05AEaaeF7b461ef6d08aCB058f02868c17",
        "symbol": "LZY",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x97df6a05AEaaeF7b461ef6d08aCB058f02868c17.png"
    },
    {
        "chainId": 369,
        "name": "PUPPERS",
        "address": "0x27246B3e508c696Af6C6F3D83286aC6D8242d3bA",
        "symbol": "PUPPERS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x27246B3e508c696Af6C6F3D83286aC6D8242d3bA.png"
    },
    {
        "chainId": 369,
        "name": "NPC",
        "address": "0xa6C897bc61270073f998FbC8d2425f01D3aDEb65",
        "symbol": "NPC",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xa6C897bc61270073f998FbC8d2425f01D3aDEb65.png"
    },
    {
        "chainId": 369,
        "name": "PUPPERS",
        "address": "0xbd59a88754902B80922dFEBc15c7ea94a8C21ce2",
        "symbol": "PUPPERS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xbd59a88754902B80922dFEBc15c7ea94a8C21ce2.png"
    },
    {
        "chainId": 369,
        "name": "DumbMoney",
        "address": "0xe65112d2f120c8cb23ADC80D8E8122c0c8b7fF8D",
        "symbol": "DUMB",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xe65112d2f120c8cb23ADC80D8E8122c0c8b7fF8D.png"
    },
    {
        "chainId": 369,
        "name": "Dumb Amplifier",
        "address": "0x8357aA9070dc7d8d154Da74561CEc58cA30c41C3",
        "symbol": "DAMP",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x8357aA9070dc7d8d154Da74561CEc58cA30c41C3.png"
    },
    {
        "chainId": 369,
        "name": "Smoki",
        "address": "0x708DACAb783DeCbB4994A9Db612Da8C2100Ab186",
        "symbol": "SMOKI",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x708DACAb783DeCbB4994A9Db612Da8C2100Ab186.png"
    },
    {
        "chainId": 369,
        "name": "Audio Ecstasy Inc",
        "address": "0x3Fa77830bFaF10e27bd1211Ff54E2D0Fd4869cA4",
        "symbol": "XTC",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x3Fa77830bFaF10e27bd1211Ff54E2D0Fd4869cA4.png"
    },
    {
        "chainId": 369,
        "name": "Richards first Car",
        "address": "0xeF7A713C3F10c12D8b12B7CBB78b79b92303Ccd4",
        "symbol": "BONNIE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xeF7A713C3F10c12D8b12B7CBB78b79b92303Ccd4.png"
    },
    {
        "chainId": 369,
        "name": "REMEMBER",
        "address": "0xC506af3eA272dAFBE1A8E39d9C3446E03637bB12",
        "symbol": "REMEMBER",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xC506af3eA272dAFBE1A8E39d9C3446E03637bB12.png"
    },
    {
        "chainId": 369,
        "name": "TrumpOfficial",
        "address": "0xf2DD4FE4bE7B8C0655d0962A4285150Ff09769EA",
        "symbol": "Trump",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xf2DD4FE4bE7B8C0655d0962A4285150Ff09769EA.png"
    },
    {
        "chainId": 369,
        "name": "Power to Profit",
        "address": "0xA831a35f48664fE357c584540fb79e172157CBF3",
        "symbol": "POWER",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xA831a35f48664fE357c584540fb79e172157CBF3.png"
    },
    {
        "chainId": 369,
        "name": "Fetch",
        "address": "0xe39B70c9978E4232140d148Ad3C0b08f4A42220D",
        "symbol": "FETCH",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xe39B70c9978E4232140d148Ad3C0b08f4A42220D.png"
    },
    {
        "chainId": 369,
        "name": "INC Dollar",
        "address": "0x144Cd22AaA2a80FEd0Bb8B1DeADDc51A53Df1d50",
        "symbol": "INCD",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x144Cd22AaA2a80FEd0Bb8B1DeADDc51A53Df1d50.png"
    },
    {
        "chainId": 369,
        "name": "INC Printer",
        "address": "0x6C203A555824ec90a215f37916cf8Db58EBe2fA3",
        "symbol": "PRINT",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6C203A555824ec90a215f37916cf8Db58EBe2fA3.png"
    },
    {
        "chainId": 369,
        "name": "GAS Money",
        "address": "0x042b48a98B37042D58Bc8defEEB7cA4eC76E6106",
        "symbol": "GAS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x042b48a98B37042D58Bc8defEEB7cA4eC76E6106.png"
    },
    {
        "chainId": 369,
        "name": "pDONG",
        "address": "0x47C7Ae1514Ee90c43e2bD50CAa8DA63285ae146d",
        "symbol": "pDONG",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x47C7Ae1514Ee90c43e2bD50CAa8DA63285ae146d.png"
    },
    {
        "chainId": 369,
        "name": "pdied",
        "address": "0xa8f501432348c5DD042347e22FBb0F0EB1528Cab",
        "symbol": "pdied",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xa8f501432348c5DD042347e22FBb0F0EB1528Cab.png"
    },
    {
        "chainId": 369,
        "name": "Surgicaltrainers.com",
        "address": "0x62bd78d40A9FCb4D29F6fF183CFbcaf2f5ca9B52",
        "symbol": "STM",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x62bd78d40A9FCb4D29F6fF183CFbcaf2f5ca9B52.png"
    },
    {
        "chainId": 369,
        "name": "QUEEN POOIE",
        "address": "0xd5cFb4Cf3f49EfAf435Cd16105Cf6a40Ef921957",
        "symbol": "QUEEN2",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xd5cFb4Cf3f49EfAf435Cd16105Cf6a40Ef921957.png"
    },
    {
        "chainId": 369,
        "name": "XGAME.IO",
        "address": "0x4Eb7C1c05087f98Ae617d006F48914eE73fF8D2A",
        "symbol": "XGAME",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x4Eb7C1c05087f98Ae617d006F48914eE73fF8D2A.png"
    },
    {
        "chainId": 369,
        "name": "SolidX from pump.tires",
        "address": "0x988aCabE384d80454995D6c9e105a4f67eA9947C",
        "symbol": "SOLIDX",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x988aCabE384d80454995D6c9e105a4f67eA9947C.png"
    },
    {
        "chainId": 369,
        "name": "Firewhale",
        "address": "0x03b4652C8565BC8c257Fbd9fA935AAE41160fc4C",
        "symbol": "FIREW",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x03b4652C8565BC8c257Fbd9fA935AAE41160fc4C.png"
    },
    {
        "chainId": 369,
        "name": "EMIT",
        "address": "0x32fB5663619A657839A80133994E45c5e5cDf427",
        "symbol": "EMIT",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x32fB5663619A657839A80133994E45c5e5cDf427.png"
    },
    {
        "chainId": 369,
        "name": "Teddy Bear HardCore",
        "address": "0x4620f185423AdC4702c7d9a22ecAAfA2dC8a5729",
        "symbol": "TBHC",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x4620f185423AdC4702c7d9a22ecAAfA2dC8a5729.png"
    },
    {
        "chainId": 369,
        "name": "Good DAI",
        "address": "0x75C84Ca7eC3F14e4f53aCAbf6eDD628cd1B22bC1",
        "symbol": "PDAI",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x75C84Ca7eC3F14e4f53aCAbf6eDD628cd1B22bC1.png"
    },
    {
        "chainId": 369,
        "name": "BEAST",
        "address": "0xdc60f0EE40bEd3078614bE202555d2f07d38166e",
        "symbol": "BEAST",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xdc60f0EE40bEd3078614bE202555d2f07d38166e.png"
    },
    {
        "chainId": 369,
        "name": "Teddy Bear from pump.tires",
        "address": "0x91Ab48C4988aE5bbEB02aCB8b5cdBCd8225D7974",
        "symbol": "TEDDY",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x91Ab48C4988aE5bbEB02aCB8b5cdBCd8225D7974.png"
    },
    {
        "chainId": 369,
        "name": "Joachim-Silver",
        "address": "0xFb7B367b80F80421d9d023D01cE9FB846A2aDa88",
        "symbol": "Thaler",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xFb7B367b80F80421d9d023D01cE9FB846A2aDa88.png"
    },
    {
        "chainId": 369,
        "name": "Free-Gold",
        "address": "0xc57169b5e803F83c28970f0d8a73e2b35d56CE32",
        "symbol": "Franc",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xc57169b5e803F83c28970f0d8a73e2b35d56CE32.png"
    },
    {
        "chainId": 369,
        "name": "Mona-Lisa",
        "address": "0x03dBe411E19436FE79Ce79DFf09B3E5f7F64644f",
        "symbol": "Moony",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x03dBe411E19436FE79Ce79DFf09B3E5f7F64644f.png"
    },
    {
        "chainId": 369,
        "name": "Teddy Claire",
        "address": "0xFd96af96B6cFb5F35Fb227b0fE7215903FdAFC68",
        "symbol": "Claire",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xFd96af96B6cFb5F35Fb227b0fE7215903FdAFC68.png"
    },
    {
        "chainId": 369,
        "name": "Tether Gold from Ethereum",
        "address": "0xD31d5463991f61B6e53b9b5ca574fA731F94991e",
        "symbol": "XAUt",
        "decimals": 6,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xD31d5463991f61B6e53b9b5ca574fA731F94991e.png"
    },
    {
        "chainId": 369,
        "name": "Pump Tires Mascot",
        "address": "0x208614c2db3e24ee2aF701538017c6a34030B1E3",
        "symbol": "PUMPY",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x208614c2db3e24ee2aF701538017c6a34030B1E3.png"
    },
    {
        "chainId": 369,
        "name": "Piggy Bank",
        "address": "0xFAaC6a85C3e123AB2CF7669B1024f146cFef0b38",
        "symbol": "OINK",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xFAaC6a85C3e123AB2CF7669B1024f146cFef0b38.png"
    },
    {
        "chainId": 369,
        "name": "Black-Hole",
        "address": "0xDC6D73BC3fF1046844386FE0301A8C6355c3E7d3",
        "symbol": "Zero",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xDC6D73BC3fF1046844386FE0301A8C6355c3E7d3.png"
    },
    {
        "chainId": 369,
        "name": "Chinta-Mani",
        "address": "0xBBC1F6cb4Ed8e1e32CeD17B2809739B093d4EFec",
        "symbol": "Emerald",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xBBC1F6cb4Ed8e1e32CeD17B2809739B093d4EFec.png"
    },
    {
        "chainId": 369,
        "name": "TOP HAT",
        "address": "0xc2472877F596D5052883B93777325dD7F7d11c96",
        "symbol": "TOPHAT",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xc2472877F596D5052883B93777325dD7F7d11c96.png"
    },
    {
        "chainId": 369,
        "name": "Sparta",
        "address": "0x52347C33Cf6Ca8D2cfb864AEc5aA0184C8fd4c9b",
        "symbol": "SPARTA",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x52347C33Cf6Ca8D2cfb864AEc5aA0184C8fd4c9b.png"
    },
    {
        "chainId": 369,
        "name": "MISSOR",
        "address": "0x063E79CF6A555dac9033EAa3c61A8f02F1020759",
        "symbol": "MISSOR",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x063E79CF6A555dac9033EAa3c61A8f02F1020759.png"
    },
    {
        "chainId": 369,
        "name": "urmom",
        "address": "0xe43b3cEE3554e120213b8B69Caf690B6C04A7ec0",
        "symbol": "urmom",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xe43b3cEE3554e120213b8B69Caf690B6C04A7ec0.png"
    },
    {
        "chainId": 369,
        "name": "GoPulse",
        "address": "0x000000000002625d361571e3771d402e10cf7ddb",
        "symbol": "GO",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x000000000002625d361571e3771d402e10cf7ddb.png"
    },
    {
        "chainId": 369,
        "name": "Pulse Golden Ticket",
        "address": "0xA99DF47d9fA5dCbe69211787faE6780bC4172492",
        "symbol": "GT",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xA99DF47d9fA5dCbe69211787faE6780bC4172492.png"
    },
    {
        "chainId": 369,
        "name": "MoonX",
        "address": "0x1C9c8528f2a1672e0E7eaDA21167a596D126B568",
        "symbol": "MOONX",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x1C9c8528f2a1672e0E7eaDA21167a596D126B568.png"
    },
    {
        "chainId": 369,
        "name": "RPE",
        "address": "0x664bAaF75570E167D66Fc0056C2d527a1d6809Cd",
        "symbol": "RPE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x664bAaF75570E167D66Fc0056C2d527a1d6809Cd.png"
    },
    {
        "chainId": 369,
        "name": "Quattro Ricos Base",
        "address": "0x01a77602eCAF9A68372CAC8d4fB247864FAAD154",
        "symbol": "T4MC",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x01a77602eCAF9A68372CAC8d4fB247864FAAD154.png"
    },
    {
        "chainId": 369,
        "name": "Quattro Ricos Son",
        "address": "0xab24834379a816Bde64a2A54df24D73aC0630dD5",
        "symbol": "T4MC",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xab24834379a816Bde64a2A54df24D73aC0630dD5.png"
    },
    {
        "chainId": 369,
        "name": "Reserve Teh",
        "address": "0x1D177CB9EfEEa49A8B97ab1C72785a3A37ABc9Ff",
        "symbol": "FED",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x1D177CB9EfEEa49A8B97ab1C72785a3A37ABc9Ff.png"
    },
    {
        "chainId": 369,
        "name": "Old Glory ELITE V6",
        "address": "0x63aa45017513B9D5bD7252F0C4752f23f77f7043",
        "symbol": "OGT+",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x63aa45017513B9D5bD7252F0C4752f23f77f7043.png"
    },
    {
        "chainId": 369,
        "name": "YEET",
        "address": "0x6Afd30110e9fF1b29dB3c4DAf31EF0045a6552cB",
        "symbol": "YEET",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6Afd30110e9fF1b29dB3c4DAf31EF0045a6552cB.png"
    },
    {
        "chainId": 369,
        "name": "The Fitzgerald Company",
        "address": "0x99F58b6979756fc129a33797eF796a6178D8A5De",
        "symbol": "TFC",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x99F58b6979756fc129a33797eF796a6178D8A5De.png"
    },
    {
        "chainId": 369,
        "name": "SURF",
        "address": "0x12828D4cdA7CBfAcd7586E54708A9b9674641bEd",
        "symbol": "SURF",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x12828D4cdA7CBfAcd7586E54708A9b9674641bEd.png"
    },
    {
        "chainId": 369,
        "name": "stCombo",
        "address": "0x2806F9d083BABbDbB9a92b0722F1b5D4E6FEF6cC",
        "symbol": "ST3",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x2806F9d083BABbDbB9a92b0722F1b5D4E6FEF6cC.png"
    },
    {
        "chainId": 369,
        "name": "Compound Dai on Pulsechain",
        "address": "0x5d3a536E4D6DbD6114cc1Ead35777bAB948E3643",
        "symbol": "cDAI",
        "decimals": 8,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x5d3a536E4D6DbD6114cc1Ead35777bAB948E3643.png"
    },
    {
        "chainId": 369,
        "name": "Pax Dollar on Pulsechain",
        "address": "0x8E870D67F660D95d5be530380D0eC0bd388289E1",
        "symbol": "USDP",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x8E870D67F660D95d5be530380D0eC0bd388289E1.png"
    },
    {
        "chainId": 369,
        "name": "DrDoge",
        "address": "0x9d95DFBB1aBb8F57abc20FDE4F786BB1Db52ad71",
        "symbol": "DRDOGE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x9d95DFBB1aBb8F57abc20FDE4F786BB1Db52ad71.png"
    },
    {
        "chainId": 369,
        "name": "PulseLand",
        "address": "0xEE126a8903b1318f2a2Eb739Fd80481da6E028D3",
        "symbol": "PLAND",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xEE126a8903b1318f2a2Eb739Fd80481da6E028D3.png"
    },
    {
        "chainId": 369,
        "name": "PulseChain Peacock",
        "address": "0xc10A4Ed9b4042222d69ff0B374eddd47ed90fC1F",
        "symbol": "PCOCK",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xc10A4Ed9b4042222d69ff0B374eddd47ed90fC1F.png"
    },
    {
        "chainId": 369,
        "name": "Liberty Swap Mascot",
        "address": "0x0eB38452FdCCab988838d9BE74e0f00239A876E6",
        "symbol": "INTERN",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x0eB38452FdCCab988838d9BE74e0f00239A876E6.png"
    },
    {
        "chainId": 369,
        "name": "Briah",
        "address": "0xA80736067abDc215a3b6B66a57c6e608654d0C9a",
        "symbol": "Briah",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xA80736067abDc215a3b6B66a57c6e608654d0C9a.png"
    },
    {
        "chainId": 369,
        "name": "The CVRE Token",
        "address": "0x483287DEd4F43552f201a103670853b5dc57D59d",
        "symbol": "CVRE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x483287DEd4F43552f201a103670853b5dc57D59d.png"
    },
    {
        "chainId": 369,
        "name": "uPLS",
        "address": "0x7FB5120D2DB148e91f572d2f69bC04FE454Dbd9b",
        "symbol": "uPLS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x7FB5120D2DB148e91f572d2f69bC04FE454Dbd9b.png"
    },
    {
        "chainId": 369,
        "name": "FuckTheVC",
        "address": "0xe4644C747dE89d363E38a32C19b9741417e79dBD",
        "symbol": "FTVC",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xe4644C747dE89d363E38a32C19b9741417e79dBD.png"
    },
    {
        "chainId": 369,
        "name": "PulseSend",
        "address": "0xD42B6CfA7A62d54124C5d78dd631fd4606bb3825",
        "symbol": "SEND",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xD42B6CfA7A62d54124C5d78dd631fd4606bb3825.png"
    },
    {
        "chainId": 369,
        "name": "Quattro Rico",
        "address": "0xf4523Ec066F92d5A2A6410496B32884E37aB629f",
        "symbol": "QR4",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xf4523Ec066F92d5A2A6410496B32884E37aB629f.png"
    },
    {
        "chainId": 369,
        "name": "Just a pulse guy",
        "address": "0x67922D590BA6C784f468B6B562d201113a8FbD2D",
        "symbol": "PULSEGUY",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x67922D590BA6C784f468B6B562d201113a8FbD2D.png"
    },
    {
        "chainId": 369,
        "name": "Napoleon Bonaparte",
        "address": "0xB4036a33009165bc741875cFb59ca73eBfB698F4",
        "symbol": "SuperMoon",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xB4036a33009165bc741875cFb59ca73eBfB698F4.png"
    },
    {
        "chainId": 369,
        "name": "Shiba-Floki",
        "address": "0x7408930DB7a6A4a66effa858D49784f94Fb82cF7",
        "symbol": "Maitreya",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x7408930DB7a6A4a66effa858D49784f94Fb82cF7.png"
    },
    {
        "chainId": 369,
        "name": "Quetzal Coatl",
        "address": "0xacd0108FA393982d9098Bb5e2C723EaF327994e0",
        "symbol": "Amaruca",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xacd0108FA393982d9098Bb5e2C723EaF327994e0.png"
    },
    {
        "chainId": 369,
        "name": "pFLANNY",
        "address": "0xBC1D0EaC2acEfB05A947c4900635701527F2B70a",
        "symbol": "PFLAN",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xBC1D0EaC2acEfB05A947c4900635701527F2B70a.png"
    },
    {
        "chainId": 369,
        "name": "Ibiza Crypto Bosses",
        "address": "0xA7704061372a523912B743139BcF447c23dB5e5E",
        "symbol": "pBOSS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xA7704061372a523912B743139BcF447c23dB5e5E.png"
    },
    {
        "chainId": 369,
        "name": "Giga Cock",
        "address": "0x14aED785b3F951Eb5aC98250E8f4f530A2F83177",
        "symbol": "GIGACOCK",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x14aED785b3F951Eb5aC98250E8f4f530A2F83177.png"
    },
    {
        "chainId": 369,
        "name": "Pentagon-Electron",
        "address": "0xE538f4D6E38bABF47e47513094483aFc4aA42E03",
        "symbol": "Magdalene",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xE538f4D6E38bABF47e47513094483aFc4aA42E03.png"
    },
    {
        "chainId": 369,
        "name": "CHOMP",
        "address": "0x7a38DfA4249B5e80cf49602E50947A47bc5edC29",
        "symbol": "CHOMP",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x7a38DfA4249B5e80cf49602E50947A47bc5edC29.png"
    },
    {
        "chainId": 369,
        "name": "FingerMonkey",
        "address": "0x60Dd286B42f704aB9B89bf34D53DF39Fb89150E6",
        "symbol": "FM",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x60Dd286B42f704aB9B89bf34D53DF39Fb89150E6.png"
    },
    {
        "chainId": 369,
        "name": "ZENDAWG",
        "address": "0xebeCbffA46Eaee7CB3B3305cCE9283cf05CfD1BB",
        "symbol": "ZEN",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xebeCbffA46Eaee7CB3B3305cCE9283cf05CfD1BB.png"
    },
    {
        "chainId": 369,
        "name": "DEV Coin",
        "address": "0xA804b9E522A2D1645a19227514CFe856Ad8C2fbC",
        "symbol": "DEVC",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xA804b9E522A2D1645a19227514CFe856Ad8C2fbC.png"
    },
    {
        "chainId": 369,
        "name": "FULL SEND",
        "address": "0x5e491D58481c4F7D255A386e491dAb32445f77Cc",
        "symbol": "SEND",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x5e491D58481c4F7D255A386e491dAb32445f77Cc.png"
    },
    {
        "chainId": 369,
        "name": "LBRTY",
        "address": "0xB261Fa283aBf9CcE0b493B50b57cb654A490f339",
        "symbol": "LBRTY",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xB261Fa283aBf9CcE0b493B50b57cb654A490f339.png"
    },
    {
        "chainId": 369,
        "name": "President Of PulseChain",
        "address": "0x79e8AE8F8a19280354dbb9ee844ED80CE9a8219d",
        "symbol": "XAVIER",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x79e8AE8F8a19280354dbb9ee844ED80CE9a8219d.png"
    },
    {
        "chainId": 369,
        "name": "Unity",
        "address": "0xC70CF25DFCf5c5e9757002106C096ab72fab299E",
        "symbol": "UNITY",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xC70CF25DFCf5c5e9757002106C096ab72fab299E.png"
    },
    {
        "chainId": 369,
        "name": "DorraWifHat",
        "address": "0x393937C233D42bB965373759EcFb6265B998F17e",
        "symbol": "DORRA",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x393937C233D42bB965373759EcFb6265B998F17e.png"
    },
    {
        "chainId": 369,
        "name": "Bella the Dog",
        "address": "0x895c1F5F4396a2a9D3DC778F63d9ddd58de8286f",
        "symbol": "BELLA",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x895c1F5F4396a2a9D3DC778F63d9ddd58de8286f.png"
    },
    {
        "chainId": 369,
        "name": "Think BIGGER",
        "address": "0x190837EB34bFC75482947a6661B006C6cB16eE03",
        "symbol": "THINK",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x190837EB34bFC75482947a6661B006C6cB16eE03.png"
    },
    {
        "chainId": 369,
        "name": "Weaponzied Autism",
        "address": "0xfED434E658DD199a30815A3698881D8248f9D400",
        "symbol": "AUTISM",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xfED434E658DD199a30815A3698881D8248f9D400.png"
    },
    {
        "chainId": 369,
        "name": "Flappy pCock",
        "address": "0xCE80eDf0E34eAB96038909411B2abEbD0b1aBE1F",
        "symbol": "FLAPPY",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xCE80eDf0E34eAB96038909411B2abEbD0b1aBE1F.png"
    },
    {
        "chainId": 369,
        "name": "DREDD AI",
        "address": "0x45462fC0b9a5eC6047484c2e572C595Df386fE61",
        "symbol": "DREDD",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x45462fC0b9a5eC6047484c2e572C595Df386fE61.png"
    },
    {
        "chainId": 369,
        "name": "ZeroTrust",
        "address": "0xf6703DBff070F231eEd966D33B1B6D7eF5207d26",
        "symbol": "ZERØ",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xf6703DBff070F231eEd966D33B1B6D7eF5207d26.png"
    },
    {
        "chainId": 369,
        "name": "zkPULSE",
        "address": "0x8De9077B619DcBdA28edda4b8dC16538a59EFb49",
        "symbol": "zkPULSE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x8De9077B619DcBdA28edda4b8dC16538a59EFb49.png"
    },
    {
        "chainId": 369,
        "name": "PIKAJEW",
        "address": "0x36fc7d749506cAA3131Fb0c5999D2D364C59498e",
        "symbol": "PIKAJEW",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x36fc7d749506cAA3131Fb0c5999D2D364C59498e.png"
    },
    {
        "chainId": 369,
        "name": "Kishka",
        "address": "0xdf2eb4E30d8ca5D76C2eA9f7E246CE0a415F1db9",
        "symbol": "KISHKA",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xdf2eb4E30d8ca5D76C2eA9f7E246CE0a415F1db9.png"
    },
    {
        "chainId": 369,
        "name": "Swarm",
        "address": "0x1E2b066d068eb087CCf85620B8306a283ea70816",
        "symbol": "SWRM",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x1E2b066d068eb087CCf85620B8306a283ea70816.png"
    },
    {
        "chainId": 369,
        "name": "Dev is Based",
        "address": "0x6F21950028418e0dFA840255daA1812200f7AB07",
        "symbol": "Based",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6F21950028418e0dFA840255daA1812200f7AB07.png"
    },
    {
        "chainId": 369,
        "name": "Honey Token",
        "address": "0xDB42c5559249BffBC917f052a54fE92Eec427AFf",
        "symbol": "HONEY",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xDB42c5559249BffBC917f052a54fE92Eec427AFf.png"
    },
    {
        "chainId": 369,
        "name": "Vouch",
        "address": "0xD34f5ADC24d8Cc55C1e832Bdf65fFfDF80D1314f",
        "symbol": "VOUCH",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xD34f5ADC24d8Cc55C1e832Bdf65fFfDF80D1314f.png"
    },
    {
        "chainId": 369,
        "name": "PulseChain Tablet",
        "address": "0xD5896371c92511eDC5EF004b229Cf7680227FAcF",
        "symbol": "TABLET",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xD5896371c92511eDC5EF004b229Cf7680227FAcF.png"
    },
    {
        "chainId": 369,
        "name": "CURV",
        "address": "0x591c914BC5c878cC398AF67681C388FaC8bdaf4e",
        "symbol": "CURV",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x591c914BC5c878cC398AF67681C388FaC8bdaf4e.png"
    },
    {
        "chainId": 369,
        "name": "HEX.COM Diamond",
        "address": "0x2858D7b77598eA9D35273ABFa86ECb25A7e490F5",
        "symbol": "5555",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x2858D7b77598eA9D35273ABFa86ECb25A7e490F5.png"
    },
    {
        "chainId": 369,
        "name": "PulseChain Peahen",
        "address": "0xFDe3255Fb043eA55F9D8635C5e7FF18770A6a810",
        "symbol": "PHEN",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xFDe3255Fb043eA55F9D8635C5e7FF18770A6a810.png"
    },
    {
        "chainId": 369,
        "name": "LeastWanted",
        "address": "0x5383526451e38D504243ACC6Ba5601B560D7B15A",
        "symbol": "LEAST",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x5383526451e38D504243ACC6Ba5601B560D7B15A.png"
    },
    {
        "chainId": 369,
        "name": "Turning Point USD",
        "address": "0x6BD7b5173CF89CA83fbCbc3113d91B41DFfdd04F",
        "symbol": "TPUSD",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6BD7b5173CF89CA83fbCbc3113d91B41DFfdd04F.png"
    },
    {
        "chainId": 369,
        "name": "CryFagging",
        "address": "0xe2b1cef3EAaCbB0E35A367aDB4A6D3993BdD3C10",
        "symbol": "CryFagg",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xe2b1cef3EAaCbB0E35A367aDB4A6D3993BdD3C10.png"
    },
    {
        "chainId": 369,
        "name": "Pulse Future",
        "address": "0x45794f23A8e8Fa4aBA05c60EaB9d0565b1d4845e",
        "symbol": "PF",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x45794f23A8e8Fa4aBA05c60EaB9d0565b1d4845e.png"
    },
    {
        "chainId": 369,
        "name": "Argyle",
        "address": "0x6095BB6323bba332567171325a549dFF69980906",
        "symbol": "ARGYLE",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6095BB6323bba332567171325a549dFF69980906.png"
    },
    {
        "chainId": 369,
        "name": "Comfy",
        "address": "0x55A06E7B2299982AC089b8b184303aCac51be835",
        "symbol": "COMFY",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x55A06E7B2299982AC089b8b184303aCac51be835.png"
    },
    {
        "chainId": 369,
        "name": "Switch Engine",
        "address": "0x6FFb7085B6f7413fbE5528f9004B1be77878018B",
        "symbol": "SWITCH",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x6FFb7085B6f7413fbE5528f9004B1be77878018B.png"
    },
    {
        "chainId": 369,
        "name": "Hamtoshi",
        "address": "0x19a8acf61f9994691144623a6324726610bc1218",
        "symbol": "HAM",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x19a8acf61f9994691144623a6324726610bc1218.png"
    },
    {
        "chainId": 369,
        "name": "VAULT 369",
        "address": "0xeB52ac4D25067185f75bab4BcbfBaFA28c876A22",
        "symbol": "VAULT",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xeB52ac4D25067185f75bab4BcbfBaFA28c876A22.png"
    },
    {
        "chainId": 369,
        "name": "Savings USDS from Ethereum",
        "address": "0x8b84bE5ED8071F6ACA12aF3311cf41C3bc673B84",
        "symbol": "sUSDS",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x8b84bE5ED8071F6ACA12aF3311cf41C3bc673B84.png"
    },
    {
        "chainId": 369,
        "name": "Grimace",
        "address": "0x1109D54A43C17c3B3d7613b0E0D0e02c984153e1",
        "symbol": "Grimace",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x1109D54A43C17c3B3d7613b0E0D0e02c984153e1.png"
    },
    {
        "chainId": 369,
        "name": "PulseChain Tiger",
        "address": "0xC2ACde27428d292C4E8e5A4A38148d6b7A2215f5",
        "symbol": "PTIGER",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xC2ACde27428d292C4E8e5A4A38148d6b7A2215f5.png"
    },
    {
        "chainId": 369,
        "name": "Tiger Crypto Dog",
        "address": "0x01272a2B4B5A7918Bb4AAbD02f4A267329EDe345",
        "symbol": "ZELDA",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x01272a2B4B5A7918Bb4AAbD02f4A267329EDe345.png"
    },
    {
        "chainId": 369,
        "name": "SCADA",
        "address": "0x69e23263927Ae53E5FF3A898d082a83B7D6fB438",
        "symbol": "SCADA",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x69e23263927Ae53E5FF3A898d082a83B7D6fB438.png"
    },
    {
        "chainId": 369,
        "name": "HERO Token for Veterans",
        "address": "0x35a51Dfc82032682E4Bda8AAcA87B9Bc386C3D27",
        "symbol": "HERO",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x35a51Dfc82032682E4Bda8AAcA87B9Bc386C3D27.png"
    },
    {
        "chainId": 369,
        "name": "Green Wick",
        "address": "0x8CDaf3d630Da9E1450832924D5701CC0500E9cfC",
        "symbol": "WICK",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x8CDaf3d630Da9E1450832924D5701CC0500E9cfC.png"
    },
    {
        "chainId": 369,
        "name": "TOUCAN",
        "address": "0x0ED3A7ea3f008FB2827F0A62Fc72FbDF2F4a8Ae5",
        "symbol": "TOUCAN",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x0ED3A7ea3f008FB2827F0A62Fc72FbDF2F4a8Ae5.png"
    },
    {
        "chainId": 369,
        "name": "Dump Tires Gold Coin",
        "address": "0xD0676B28a457371D58d47E5247b439114e40Eb0F",
        "symbol": "DTGC",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xD0676B28a457371D58d47E5247b439114e40Eb0F.png"
    },
    {
        "chainId": 369,
        "name": "Cipher",
        "address": "0xb20f8de69250f76AC4324815193BdC8a2F7E8eA3",
        "symbol": "CIPHER",
        "decimals": 6,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xb20f8de69250f76AC4324815193BdC8a2F7E8eA3.png"
    },
    {
        "chainId": 369,
        "name": "Coin Mafia",
        "address": "0x562866b6483894240739211049E109312E9A9A67",
        "symbol": "MAFIA",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0x562866b6483894240739211049E109312E9A9A67.png"
    },
    {
        "chainId": 369,
        "name": "NEXION",
        "address": "0xF2Da3942616880E52e841E5C504B5A9Fba23FFF0",
        "symbol": "NEON",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xF2Da3942616880E52e841E5C504B5A9Fba23FFF0.png"
    },
    {
        "chainId": 369,
        "name": "ProveX",
        "address": "0xF6f8Db0aBa00007681F8fAF16A0FDa1c9B030b11",
        "symbol": "PRVX",
        "decimals": 18,
        "logoURI": "https://raw.githubusercontent.com/libertyswap-finance/app-tokens/main/token-logo/0xF6f8Db0aBa00007681F8fAF16A0FDa1c9B030b11.png"
    }
]